{
  "suits": [
    {
      "id": "home",
      "name": "Home",
      "count": 22
    },
    {
      "id": "out",
      "name": "Out",
      "count": 22
    },
    {
      "id": "caregiving",
      "name": "Caregiving",
      "count": 22
    },
    {
      "id": "magic",
      "name": "Magic",
      "count": 22
    },
    {
      "id": "wild",
      "name": "Wild",
      "count": 10
    },
    {
      "id": "unicorn",
      "name": "Unicorn Space",
      "count": 2
    }
  ],
  "cards": [
    {
      "id": "childcare-helpers-kids",
      "slug": "childcare-helpers-kids",
      "sourceId": 4,
      "suit": "home",
      "name": "Childcare Helpers (Kids)",
      "fullName": "Childcare Helpers (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 10,
      "definition": "It takes a village, and you’re fortunate if your village includes a nanny, babysitter, family caregivers, or others who pitch in with the kids. It can be a lifesaver to have the help, but it still requires someone to Conceive and Plan before Nanny Poppins or Grandma Shirley shows up to help Execute. They don’t magically appear when we want them to, so schedules need to be managed, along with payment, delegation of responsibilities, and ongoing communication. Heads up: When your helper cancels or quits, this cardholder is not necessarily the one who drops everything. Rather, engage in Fair Play immediately to re-deal the applicable cards, for example, “Transportation (Kids)” and “Watching.”",
      "conception": "Someone needs to be able to help with the children",
      "planning": [
        {
          "t": "li",
          "text": "Discussing with stakeholders what is needed for the home at this stage of life"
        },
        {
          "t": "li",
          "text": "Sourcing if not family (websites/word of mouth/agency)"
        },
        {
          "t": "li",
          "text": "Transportation concerns: car seats, boosters, etc."
        },
        {
          "t": "li",
          "text": "Interviewing (scheduling, conducting, reference checking)"
        },
        {
          "t": "li",
          "text": "Scheduling days they will be working"
        },
        {
          "t": "li",
          "text": "Planning terms, including payment – hourly vs. salary, on or off the books, determining payment vehicle/employer"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Hiring (negotiating terms/contract)"
        },
        {
          "t": "li",
          "text": "Ongoing communication & supervision"
        },
        {
          "t": "li",
          "text": "Making payments"
        },
        {
          "t": "li",
          "text": "Purchasing/providing meals & snacks for helper"
        },
        {
          "t": "li",
          "text": "Reimbursing: Gas, meals, & other termination issues"
        }
      ],
      "msc": "Will they show up when you need them, know what they are supposed to do and are paid on time?",
      "resources": []
    },
    {
      "id": "cleaning",
      "slug": "cleaning",
      "sourceId": 5,
      "suit": "home",
      "name": "Cleaning",
      "fullName": "Cleaning",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 20,
      "definition": "The pancake batter that fell into the crack on the side of the oven? Last week? It’s still there. The pee all over the toilet seat because your toddler can’t aim? Still there. The trail of sand in your entryway post-playground? Still there. If you have someone to help deep clean your bathroom and kitchen—lucky you. It’s still your responsibility to manage the schedule, task list, payment, etc. Re-deal this card often, as it’s a biggie. Tip! Coordinate with the “Home Goods & Supplies” cardholder so you have cleaning supplies in the house when you need them.",
      "conception": "The house needs to be clean",
      "planning": [
        {
          "t": "p",
          "text": "INSOURCED"
        },
        {
          "t": "li",
          "text": "Communicating with “Home Goods & Supplies” cardholder for supplies OUTSOURCED"
        },
        {
          "t": "li",
          "text": "Sourcing"
        },
        {
          "t": "li",
          "text": "Communicating with “Home Goods & Supplies” cardholder for supplies"
        },
        {
          "t": "li",
          "text": "Scheduling"
        },
        {
          "t": "li",
          "text": "Interviewing"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Hiring"
        },
        {
          "t": "li",
          "text": "Ongoing communication & supervision"
        },
        {
          "t": "li",
          "text": "Making payments"
        },
        {
          "t": "li",
          "text": "Reimbursing to purchase supplies DAILY/WEEKLY"
        },
        {
          "t": "li",
          "text": "Bed making"
        },
        {
          "t": "li",
          "text": "Counter-top cleaning"
        },
        {
          "t": "li",
          "text": "Vacuuming floors/carpets/couches"
        },
        {
          "t": "li",
          "text": "Bathroom toilet bowl cleaning/floor mopping"
        },
        {
          "t": "li",
          "text": "Bathtub/shower tile and glass OCCASIONAL"
        },
        {
          "t": "li",
          "text": "Carpets/floor"
        },
        {
          "t": "li",
          "text": "Drapes"
        },
        {
          "t": "li",
          "text": "Dusting"
        },
        {
          "t": "li",
          "text": "Toys"
        },
        {
          "t": "li",
          "text": "Window washing"
        },
        {
          "t": "li",
          "text": "Defrosting refrigerator/freezer"
        },
        {
          "t": "li",
          "text": "Outdoor grill/barbecue/furniture"
        },
        {
          "t": "li",
          "text": "Upholstery"
        }
      ],
      "msc": "Will our home be reasonably clean and safe for our family?",
      "resources": []
    },
    {
      "id": "dishes",
      "slug": "dishes",
      "sourceId": 6,
      "suit": "home",
      "name": "Dishes",
      "fullName": "Dishes",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 30,
      "definition": "It’s no wonder so many articles about domestic labor begin and end with dishes—the metaphorical third rail of chores. This cardholder is responsible for washing and drying by hand and/or loading and unloading the dishwasher—for every meal. The upside? Your partner doesn’t get to criticize how you put the plates in the “wrong” way. Re-deal this card often to avoid thrown dishes.",
      "conception": "Dishes are being used, and therefore need to be cleaned",
      "planning": [
        {
          "t": "li",
          "text": "Paying special care to specialty items like non-stick and cast-iron items"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Washing and drying dishes and pots and pans (by hand)"
        },
        {
          "t": "li",
          "text": "Loading and unloading dishwasher"
        },
        {
          "t": "li",
          "text": "Putting dishes away in proper location"
        }
      ],
      "msc": "Are the dishes appropriately handled? Clean dry and put away on a regular basis? (i.e pans hand-washed if needed)",
      "resources": []
    },
    {
      "id": "dry-cleaning",
      "slug": "dry-cleaning",
      "sourceId": 7,
      "suit": "home",
      "name": "Dry Cleaning",
      "fullName": "Dry Cleaning",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 40,
      "definition": "Even something as seemingly straightforward as dry cleaning requires step-by-step CPE. This card entails having a bin/bag at home, ensuring the appropriate clothes get into that bin/bag, finding a dry cleaner, knowing when it’s open so you can coordinate drop-off and pickup, and taking off the plastic wrapping before hanging clothes back in the closet. If the mutually agreed-upon MSC is that all clothes come back home, this cardholder is responsible for tracking down their spouse’s favorite shirt when it goes missing or negotiating a refund. (And maybe finding a new dry cleaner, too.)",
      "conception": "Certain clothes need to be dry cleaned",
      "planning": [
        {
          "t": "li",
          "text": "Researching appropriate dry cleaner for pricing, location and hours"
        },
        {
          "t": "li",
          "text": "Setting up account at dry cleaner for payment"
        },
        {
          "t": "li",
          "text": "Scheduling pick-up/drop-off or physical pick-up and drop-off in store"
        },
        {
          "t": "li",
          "text": "Taking inventory of pieces dropped off"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing dry-cleaning bin/or bag and making sure appropriate clothes are in the bin"
        },
        {
          "t": "li",
          "text": "Tagging pants/shirts with stains"
        },
        {
          "t": "li",
          "text": "Ensuring matching pieces picked up"
        },
        {
          "t": "li",
          "text": "Taking off plastic wrapping and placing clothes in closet"
        }
      ],
      "msc": "Are your dry-cleaned clothes ready and clean when you need them?",
      "resources": []
    },
    {
      "id": "garbage",
      "slug": "garbage",
      "sourceId": 8,
      "suit": "home",
      "name": "Garbage",
      "fullName": "Garbage",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 50,
      "definition": "Really, how much darn trash can one family create? Staggering. To CPE this card means, at minimum, you take out the trash before the garbage truck turns the corner of your block (which day is it again?). Whoever holds this card is responsible for anticipating when trash bags are running low, and a word to the wise: Don’t you dare sit back down on the couch until you put a new bag back in the trash can!",
      "conception": "Things will be thrown away, meaning you will have garbage",
      "planning": [
        {
          "t": "p",
          "text": "All Non-Apartment Dwellers:"
        },
        {
          "t": "li",
          "text": "Applying to the city/municipality for garbage bins"
        },
        {
          "t": "li",
          "text": "Taking note of garbage day"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Placing/replacing bag in home trash can"
        },
        {
          "t": "li",
          "text": "Removing full garbage bags"
        },
        {
          "t": "li",
          "text": "Placing full garbage bags in trash shoot/outdoor bins"
        },
        {
          "t": "li",
          "text": "Labeling bins"
        },
        {
          "t": "li",
          "text": "Taking bins back out/in, driving to town dump/placing garbage in alley"
        },
        {
          "t": "li",
          "text": "Checking bins for overflow trash/keeping bins clean"
        }
      ],
      "msc": "Is trash out of your home before it overflows, and if applicable, did the cans go out before trash day?",
      "resources": []
    },
    {
      "id": "groceries",
      "slug": "groceries",
      "sourceId": 9,
      "suit": "home",
      "name": "Groceries",
      "fullName": "Groceries",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 60,
      "definition": "Your family needs to eat. Can we all agree on that? Good. So how do the pantry and refrigerator get stocked on an ongoing basis? With CPE. This includes noticing what’s about to be used up or expire, keeping a running grocery list, and getting to the market . . . ideally before you realize there’s not a drop of milk in the fridge. Even if your family orders groceries online and your go-to dinner is frozen pizza, this card requires CPE nearly 365 days a year. Consult the various “Meals” cardholders regularly so you can be sure you have taco shells in the cupboard for taco night.",
      "conception": "Your family needs to eat",
      "planning": [
        {
          "t": "li",
          "text": "Making a master list (consulting with “Meals” cardholder)"
        },
        {
          "t": "li",
          "text": "Checking refrigerator and pantry for what is low and adding to list"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Shopping (grocery stores and/or online)"
        },
        {
          "t": "li",
          "text": "Loading and unloading groceries"
        },
        {
          "t": "li",
          "text": "Placing items in pantry/refrigerator"
        },
        {
          "t": "li",
          "text": "Throwing away expired items from refrigerator/freezer"
        }
      ],
      "msc": "Shopping (grocery stores and/or online) Loading and unloading groceries Placing items in pantry/refrigerator Throwing away expired items from refrigerator/freezer",
      "resources": []
    },
    {
      "id": "home-furnishings",
      "slug": "home-furnishings",
      "sourceId": 10,
      "suit": "home",
      "name": "Home Furnishings",
      "fullName": "Home Furnishings",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 70,
      "definition": "CPEing this card can be as basic as making sure that every bed has a pillow, you have towels in the closet, and the drinking glasses with cracks get replaced before someone chips a tooth. This card is not a one-time deal, as there’s regular inventory to be taken and just when you could use that 20 percent off Bed Bath and Beyond coupon, it’s nowhere to be found. Kindly discuss with the “Points, Miles, & Coupons” cardholder so you’re buttoned up for your next trip to the store.",
      "conception": "The house needs to be clean",
      "planning": [
        {
          "t": "li",
          "text": "Creating an inventory of what is needed"
        },
        {
          "t": "li",
          "text": "Researching items for price, look and functionality"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing items for the home: pots and pans, cutlery, dishes, towels, sheets, hand towels, pillows (beds, couches, etc.), mattresses, duvets, picture frames, candles, door mats, art/posters, appliances, bed frames, couches, dressers, chairs, dining room table, drapes/shades, kitchen table and chairs, stools, carpets/rugs, trash cans, bedside tables, lamps, coffee table items, book shelves, fireplace, and outdoor items."
        },
        {
          "t": "li",
          "text": "Replacing broken/outdated items"
        },
        {
          "t": "li",
          "text": "Placing items in appropriate area in consultation with “Organizing” cardholder"
        }
      ],
      "msc": "Once you agree on a plan for what your home should look like, is that plan implemented?",
      "resources": []
    },
    {
      "id": "home-goods-and-supplies",
      "slug": "home-goods-and-supplies",
      "sourceId": 11,
      "suit": "home",
      "name": "Home Goods & Supplies",
      "fullName": "Home Goods & Supplies",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 80,
      "definition": "This card requires CPE of everything from laundry detergent, batteries, and lightbulbs, to toothpaste, coffee filters, and trash bags! Expect to be astounded by how your parents’ generation pulled this off without Amazon.",
      "conception": "Your family needs home goods & supplies",
      "planning": [
        {
          "t": "li",
          "text": "Creating an inventory/making a master list (detergent, cleaning supplies, paper products, batteries, office supplies, bathroom supplies/toiletries/ Ziplock bags, Tupperware, lunch boxes)"
        },
        {
          "t": "li",
          "text": "Checking supplies for what is low"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Shopping"
        },
        {
          "t": "li",
          "text": "Loading and unloading goods/supplies"
        },
        {
          "t": "li",
          "text": "Placing items in appropriate area in consultation with “Organizing” cardholder"
        }
      ],
      "msc": "Is there regular replenishment of home goods / are the goods & supplies there when you need them? Are they in the appropriate place when you need them? (i.e the toilet paper back on the holder)",
      "resources": []
    },
    {
      "id": "home-maintenance",
      "slug": "home-maintenance",
      "sourceId": 12,
      "suit": "home",
      "name": "Home Maintenance",
      "fullName": "Home Maintenance",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 90,
      "definition": "How many people does it take to change a lightbulb? In this game, just one, and it’s the person holding this card. You’re also responsible for unclogging toilets, calling a repairman when the air conditioner breaks (inevitably in the height of summer), finding the manual for the vacuum cleaner that’s spewing dust, and every other home maintenance to-do that requires hands-on CPE.",
      "conception": "Things in the home will break",
      "planning": [
        {
          "t": "li",
          "text": "Making a master list and keeping track of weekly/monthly/annual home tasks that involve maintenance."
        },
        {
          "t": "li",
          "text": "Sourcing (if applicable)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Hiring"
        },
        {
          "t": "li",
          "text": "Ongoing communication and supervision"
        },
        {
          "t": "li",
          "text": "Making payments"
        },
        {
          "t": "li",
          "text": "Reimbursing to purchase supplies OUTSOURCED"
        },
        {
          "t": "li",
          "text": "Hiring"
        },
        {
          "t": "li",
          "text": "Making payments"
        },
        {
          "t": "li",
          "text": "Communicating and supervising"
        },
        {
          "t": "li",
          "text": "Placing orders for parts/broken items INSOURCED (DIY)"
        },
        {
          "t": "li",
          "text": "Plumbing: toilet, sink, garbage disposal, water issues (filters, heater, softeners, mineral deposits, inspections), septic tank"
        },
        {
          "t": "li",
          "text": "Electrical: light bulbs, light fixtures, wiring"
        },
        {
          "t": "li",
          "text": "Interior: HVAC, air ducts, smoke detectors, vents, insulation, cabinets, appliance management, paint, fireplace/chimney, home security, exterminator"
        },
        {
          "t": "li",
          "text": "Exterior: roof/siding, tiles, gutters, power washing, pool(cleaning, draining, chemicals, pool skimmer, pool vacuum), exterior walkway cracks and paint, weather proofing, driveway (snow shoveling etc.)"
        }
      ],
      "msc": "Is there someone monitoring and timely handling repairs and upkeep in the home?",
      "resources": []
    },
    {
      "id": "home-purchase-rental-mortgage-and-insurance",
      "slug": "home-purchase-rental-mortgage-and-insurance",
      "sourceId": 13,
      "suit": "home",
      "name": "Home Purchase (Rental, Mortgage & Insurance)",
      "fullName": "Home Purchase (Rental, Mortgage & Insurance)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 100,
      "definition": "If you aspire to be a homeowner with a mortgage one day, then when the time comes, you’ll need to CPE the purchasing process. If you’re already a homeowner with a mortgage, this cardholder oversees title insurance, reviewing an infinite amount of statements, and possible refinancing. If you’re looking to rent, then you’ll be the one to scour listings, fill out applications, and furnish your credit score. You’ll also handle home insurance (whether you rent or own), including evaluating the appropriate policy and filing claims if needed. Grab this card fast if paperwork and record-keeping are your strong suits.",
      "conception": "Your family needs a place to live",
      "planning": [
        {
          "t": "li",
          "text": "Researching neighborhoods (affordability consulting with “Money Manager” cardholder, local schools, parks, safety)"
        },
        {
          "t": "li",
          "text": "Selecting home Realtor or rental broker, mortgage broker/lender"
        },
        {
          "t": "li",
          "text": "Attending open houses and touring homes/apartments"
        },
        {
          "t": "li",
          "text": "Securing pre-approval from bank for loan (including managing appraisers)"
        },
        {
          "t": "li",
          "text": "Managing financial documentation (tax returns, bank statements, income verification)"
        },
        {
          "t": "li",
          "text": "Ensuring credit score is up to par"
        },
        {
          "t": "li",
          "text": "Budgeting for mortgage payment, property tax/insurance, assessments & other homeowner expenses"
        },
        {
          "t": "li",
          "text": "Researching homeowners/renters insurance & other possible other options (earthquake, flood, etc.)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Making offer (process) and managing closing"
        },
        {
          "t": "li",
          "text": "Attending and managing inspections"
        },
        {
          "t": "li",
          "text": "Making down payment money available"
        },
        {
          "t": "li",
          "text": "Purchasing homeowners/renters insurance and possible other options"
        }
      ],
      "msc": "Do you have keys to your pad? Plus insurance for your home and most important items?",
      "resources": []
    },
    {
      "id": "hosting",
      "slug": "hosting",
      "sourceId": 14,
      "suit": "home",
      "name": "Hosting",
      "fullName": "Hosting",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 110,
      "definition": "Whether it’s a backyard barbecue, potluck dinner, or any other get-together in your home or elsewhere, hosting often entails sending out invites, planning the menu, filling a vase with flowers, and setting the table (and maybe a separate one for the kids). The downside to holding this card: You may forget to have fun at your own shindig as you bend over backward to ensure everyone else does. The upside: no need for a workout on hosting days, as you will probably hit 10,000 steps before you sit down to eat (if you get to at all).",
      "conception": "You want to have people over",
      "planning": [
        {
          "t": "li",
          "text": "Creating plan for the event"
        },
        {
          "t": "li",
          "text": "Curating guest list"
        },
        {
          "t": "li",
          "text": "Managing RSVPs"
        },
        {
          "t": "li",
          "text": "Coordinating what guests may bring"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Sending invitations"
        },
        {
          "t": "li",
          "text": "Purchasing/rentals: food, drinks, tableware, flowers, music, seating"
        },
        {
          "t": "li",
          "text": "Decorating (streamers, balloons, flowers, place cards, centerpieces, confetti)"
        },
        {
          "t": "li",
          "text": "Hiring servers/helpers"
        },
        {
          "t": "li",
          "text": "Setting up"
        },
        {
          "t": "li",
          "text": "Cleaning up"
        }
      ],
      "msc": "Did your guests have a good time and were their expectations met based on the event?",
      "resources": []
    },
    {
      "id": "laundry",
      "slug": "laundry",
      "sourceId": 15,
      "suit": "home",
      "name": "Laundry",
      "fullName": "Laundry",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 120,
      "definition": "If you haven’t ever CPE’d this card, would you like to take a guess at how many loads of laundry your family generates weekly? A freakin’ lot, that’s my guess. If you never go a day without clean socks and your daughter can always find her favorite rainbow shirt, then be sure to thank this cardholder, who not only throws the load in the washer and dryer but also folds it and puts it all away. If laundry tends to pile up and multiply in your home, it’s time to re-deal this card and come up with a new standard before the next cycle begins.",
      "conception": "Laundry needs to be done, clothes need to be cleaned",
      "planning": [
        {
          "t": "li",
          "text": "Sorting clothes"
        },
        {
          "t": "li",
          "text": "Reviewing clothing instructions (colors/whites/delicates)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Spraying stains pre-wash"
        },
        {
          "t": "li",
          "text": "Washing/drying"
        },
        {
          "t": "li",
          "text": "Ironing/steaming"
        },
        {
          "t": "li",
          "text": "Hanging, folding, putting away"
        }
      ],
      "msc": "Are there laundered clothes when you need them where you need them in their place in the respective closets? (i.e not all over the floor or wrinkled in the dryer)",
      "resources": []
    },
    {
      "id": "lawn-and-plants",
      "slug": "lawn-and-plants",
      "sourceId": 16,
      "suit": "home",
      "name": "Lawn & Plants",
      "fullName": "Lawn & Plants",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 130,
      "definition": "If you’ve got a lawn, a backyard or balcony vegetable garden, or just a struggling succulent by your kitchen window, then you know it takes careful CPE to keep your greenery alive, no less thriving. Even if you have a helpful gardener to lend you his or her green thumb, it’s still on you to keep an eye on limp or leggy plants that may need a shot of Miracle-Gro.",
      "conception": "You have a lawn & plants",
      "planning": [
        {
          "t": "li",
          "text": "Researching appropriate plants for home (climate, sunlight exposure, seasonal, water usage/drought resistance)"
        },
        {
          "t": "li",
          "text": "Defining maintenance plan"
        },
        {
          "t": "li",
          "text": "Managing weather conditions OUTSOURCED (LANDSCAPE, GARDENER, LAWN MOWER, ETC.)"
        },
        {
          "t": "li",
          "text": "Sourcing"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Executing maintenance plan"
        },
        {
          "t": "li",
          "text": "System control (sprinkler set-up, daylight saving times, stay apprised of local laws on watering)"
        },
        {
          "t": "li",
          "text": "Purchasing seeds, flowers, plants, fertilizer, sod, mulch, soil, shovels, gloves, trimming supplies, chain saw, wheel barrel"
        },
        {
          "t": "li",
          "text": "Lawn/garden maintenance (mowing, fertilizing, weeds and pesticides)"
        },
        {
          "t": "li",
          "text": "Pest control: monitor pet/animal/insect prevention"
        },
        {
          "t": "li",
          "text": "Pruning/trimming/raking/citrus removal: trees, bushes, flowers"
        },
        {
          "t": "li",
          "text": "Hiring"
        },
        {
          "t": "li",
          "text": "Paying"
        },
        {
          "t": "li",
          "text": "Managing & communicating (including access plan)"
        }
      ],
      "msc": "Are your plants/lawn alive with no safety hazards?",
      "resources": []
    },
    {
      "id": "mail",
      "slug": "mail",
      "sourceId": 17,
      "suit": "home",
      "name": "Mail",
      "fullName": "Mail",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 140,
      "definition": "This cardholder isn’t only responsible for grabbing the mail every day on the way in the front door. It’s what happens once the mail is inside your home that’s most important. This CPEer will have a system for retrieving and opening mail in a timely, date-sensitive manner, and then handing off invitations, bills, jury duty notices, health insurance reimbursements, tax refunds, etc., to their rightful owner. Perk: This cardholder gets to choose between the Star Wars or Elvis commemorative stamps for your family’s outgoing mail because now it’s your job to buy ’em and stick ’em.",
      "conception": "Mail",
      "planning": [
        {
          "t": "li",
          "text": "Knowing when the mail comes & gets picked up"
        },
        {
          "t": "li",
          "text": "Planning what post office you will use and knowing when it is open"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Retrieving mail daily"
        },
        {
          "t": "li",
          "text": "Opening and sorting mail"
        },
        {
          "t": "li",
          "text": "Giving bills to “Cash Management & Bills” cardholder, tax forms to “Money Manager” cardholder, invitations to “Calendar Keeper” cardholder, and health insurance forms to “Health Insurance” cardholder"
        },
        {
          "t": "li",
          "text": "Purchasing stamps"
        },
        {
          "t": "li",
          "text": "Mailing outgoing mail"
        },
        {
          "t": "li",
          "text": "Shipping & picking up packages at post office"
        }
      ],
      "msc": "Is the mail coming in every day and getting sorted in a timely manner? Do packages need to be picked up before they are shipped back to the sender?",
      "resources": []
    },
    {
      "id": "meals-kids-school-lunch",
      "slug": "meals-kids-school-lunch",
      "sourceId": 18,
      "suit": "home",
      "name": "Meals (Kids; School Lunch)",
      "fullName": "Meals (Kids; School Lunch)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 150,
      "definition": "If you’re this cardholder, toss the idea of a relaxing night out the window because it’s time to start packing lunch for the kids. Don’t let all the #schoollunch pics on Instagram get you down. Your Fair Play Minimum Standard of Care could be a protein bar, an apple, and a bottle of water if that’s all your kid will eat. And even if your child’s school provides lunch, you still have to take the lead and sign up for this program and provide lunch money to cover pizza Fridays.",
      "conception": "The kids need to eat lunch",
      "planning": [
        {
          "t": "p",
          "text": "INSOURCED"
        },
        {
          "t": "li",
          "text": "Menu and snack planning and purchasing containers (give list of items needed to “Home Goods & Supplies” cardholder or purchase yourself) OUTSOURCED"
        },
        {
          "t": "li",
          "text": "Log into school portal to order school lunch and/or add money to account (exception: all other school forms go to “School Forms” cardholder)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Preparing and packing into container (including filling daily water bottle and providing utensils/ice packs)"
        },
        {
          "t": "li",
          "text": "Staying apprised of what child is eating/not eating"
        }
      ],
      "msc": "Do the kids have a reasonably nutritious meal in their backpack every day and/or is it ordered and paid for (access to money)?",
      "resources": []
    },
    {
      "id": "meals-weekday-breakfast",
      "slug": "meals-weekday-breakfast",
      "sourceId": 19,
      "suit": "home",
      "name": "Meals (Weekday Breakfast)",
      "fullName": "Meals (Weekday Breakfast)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 160,
      "definition": "One mom we spoke to lamented that she’s held this card every single day since her kids were old enough to eat solids. Every. Single. Day. Prepare to frequently re-deal full CPE of this nonnegotiable Daily Grind unless serving oatmeal and toast at breakneck speed is your jam. Dishes left in the sink and milk spilled on the counter isn’t “on you” unless you hold the “dishes” and “tidying” cards. Still, be respectful before you zoom out the door.",
      "conception": "Your family needs to eat breakfast",
      "planning": [
        {
          "t": "li",
          "text": "Menu planning/recipe selection"
        },
        {
          "t": "li",
          "text": "Making lists of items needed (give to “Groceries” cardholder with appropriate amount of time or purchase yourself)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Cooking/preparing"
        },
        {
          "t": "li",
          "text": "Serving"
        },
        {
          "t": "li",
          "text": "Putting dishes in sink for “Dishes” cardholder"
        }
      ],
      "msc": "Is your family fed a reasonably nutritious meal during the appropriate time window for each meal?",
      "resources": []
    },
    {
      "id": "meals-weekday-dinner",
      "slug": "meals-weekday-dinner",
      "sourceId": 20,
      "suit": "home",
      "name": "Meals (Weekday Dinner)",
      "fullName": "Meals (Weekday Dinner)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 170,
      "definition": "If you have never CPE’d dinnertime in a family with kids (particularly young ones), then no words can really do justice to this nightly circus. The ringleader plans a weekly menu, consults the “groceries” cardholder to have the ingredients at home, then cooks, ensures that the food actually gets eaten, and ideally uses this forced family time to have “quality” conversations about everyone’s day. Men: Kudos to you if cooking is one of your domestic contributions, but that’s just one word on this doozy of a card. Hero status isn’t awarded for just pulling out a frying pan.",
      "conception": "Your family needs to eat dinner",
      "planning": [
        {
          "t": "li",
          "text": "Menu planning/recipe selection"
        },
        {
          "t": "li",
          "text": "Making lists of items needed (give to “Groceries” cardholder with appropriate amount of time or purchase yourself)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Cooking/preparing"
        },
        {
          "t": "li",
          "text": "Serving"
        },
        {
          "t": "li",
          "text": "Putting dishes in sink for “Dishes” cardholder"
        }
      ],
      "msc": "Is your family fed a reasonably nutritious meal during the appropriate time window for each meal.",
      "resources": []
    },
    {
      "id": "meals-weekend",
      "slug": "meals-weekend",
      "sourceId": 21,
      "suit": "home",
      "name": "Meals (Weekend)",
      "fullName": "Meals (Weekend)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 180,
      "definition": "Why do weekend meals feel more burdensome than weekday meals? Oh, let us count the ways. Maybe it’s because there are twice as many of them than on a school day. Perhaps it’s because they amplify the kitchen mess exponentially. Or because when you make it to Saturday night, you’re still only halfway there. Weekend meals deserve their own card—who wants it? Psst. Serving lunch at 4 p.m. doesn’t cut it unless midday meltdowns are your thing.",
      "conception": "Your family needs to eat on weekends",
      "planning": [
        {
          "t": "li",
          "text": "Menu planning/recipe selection"
        },
        {
          "t": "li",
          "text": "Making lists of items needed (give to “Groceries” cardholder with appropriate amount of time or purchase yourself)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Cooking/preparing"
        },
        {
          "t": "li",
          "text": "Serving"
        },
        {
          "t": "li",
          "text": "Putting dishes in sink for “Dishes” cardholder"
        }
      ],
      "msc": "Is your family fed a reasonably nutritious meal during the appropriate time window for each meal. (i.e, Lunch at 4 pm doesn’t cut it when kids last ate at 8 am.)",
      "resources": []
    },
    {
      "id": "memories-and-photos",
      "slug": "memories-and-photos",
      "sourceId": 22,
      "suit": "home",
      "name": "Memories & Photos",
      "fullName": "Memories & Photos",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 190,
      "definition": "God bless those parents who make photo albums every year and who can rest assured that if the basement flooded, all their old photos are scanned and backed up in the cloud. No need to aim that high, but if you hold this card, your family’s lifelong memories are nevertheless in your hands. When a photo collage is needed for “Student of the Week,” it’s time to cue the music . . . and kiss some of your time goodbye. When the boxes of your child’s artwork that you’ve been collecting since kindergarten threaten to take over every wall in your home, it’s time to consult with the “Storage” and “Organizing” cardholder. Do we keep it all or secretly recycle?",
      "conception": "Does your family have photos?",
      "planning": [
        {
          "t": "li",
          "text": "Researching photo storage and backup options: cloud options by storage fees and functionality, and/or hard drive"
        },
        {
          "t": "li",
          "text": "Signing up for cloud accounts, including managing usernames and passwords"
        },
        {
          "t": "li",
          "text": "Arranging family photo shoots"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Taking pictures"
        },
        {
          "t": "li",
          "text": "Organizing digital photos into folders"
        },
        {
          "t": "li",
          "text": "Creating photo books and/or printing photos"
        },
        {
          "t": "li",
          "text": "Digitizing old photos (scan, upload, file)"
        },
        {
          "t": "li",
          "text": "Creating home videos / photo montages"
        }
      ],
      "msc": "Are the appropriate photos readily accessible when you need them? Are you capturing memories you desire?",
      "resources": []
    },
    {
      "id": "money-manager",
      "slug": "money-manager",
      "sourceId": 23,
      "suit": "home",
      "name": "Money Manager",
      "fullName": "Money Manager",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 200,
      "definition": "If you’re taking the lead on this card, you are intrepid because managing a family’s budget is no small feat. Planning for the present and preparing for the future is a good start, but there’s so much more to CPEing this card. Short and long-time budgeting. Paying off debt. Retirement planning. College savings and 401(k) investments. And of course there’s also the fun that rolls around every April 15. Day-to-day “Cash & Bills” is a separate card, and these cardholders will collaborate often.",
      "conception": "Is there money that needs to be managed?",
      "planning": [
        {
          "t": "li",
          "text": "Researching investments etc. (self)"
        },
        {
          "t": "li",
          "text": "Researching broker/investment adviser/online brokerage and all issues related to retirement, college, emergency funds etc."
        },
        {
          "t": "li",
          "text": "Tax planning"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Managing investment accounts (including 401k/retirement and college funds) with financial adviser/online broker (in or Outsourced)"
        },
        {
          "t": "li",
          "text": "Managing family budget (income and expenses)"
        },
        {
          "t": "li",
          "text": "Tax receipt and form collecting and filing appropriate forms (self, tax preparation software, or with accountant)"
        },
        {
          "t": "li",
          "text": "Depositing checks in bank account"
        }
      ],
      "msc": "Do you have a budget / financial plan? Are you intentional about for planning for the future? Are you on the same page with paying off debt and are taxes filed on time (or an appropriate agreed upon extension)?",
      "resources": []
    },
    {
      "id": "storage-garage-and-seasonal-items",
      "slug": "storage-garage-and-seasonal-items",
      "sourceId": 24,
      "suit": "home",
      "name": "Storage, Garage & Seasonal Items",
      "fullName": "Storage, Garage & Seasonal Items",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 210,
      "definition": "If you have a storage unit or a garage, do you have any idea what’s inside it? If not, now is the time to get it organized and have a CPE plan in place before someone asks, “Honey, where’s Zach’s sleeping bag? He has a sleepover tonight.”",
      "conception": "We have storage",
      "planning": [
        {
          "t": "li",
          "text": "Inventory management of summer/beach/lake/camping/bikes/pool items or winter items"
        },
        {
          "t": "li",
          "text": "Researching and renting storage unit"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Managing items in garage (place in bins, racks, shelving etc.) or give away to “Tidying Up, Organizing, & Donations” cardholder)"
        },
        {
          "t": "li",
          "text": "Tidy shelves and storage in garage"
        },
        {
          "t": "li",
          "text": "Air in bicycle tires, sports balls, pool rafts"
        },
        {
          "t": "li",
          "text": "Organize sports, ski, and camping equipment and/or luggage"
        }
      ],
      "msc": "Is the garage or unit reasonably organized? Can you find things when you need them?",
      "resources": []
    },
    {
      "id": "tidying-up-organizing-and-donations",
      "slug": "tidying-up-organizing-and-donations",
      "sourceId": 25,
      "suit": "home",
      "name": "Tidying Up, Organizing & Donations",
      "fullName": "Tidying Up, Organizing & Donations",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 220,
      "definition": "This never-ending work includes making beds, putting toys away, finding the Legos under the couch (preferably before you buy a whole new set), and wrapping up the half a banana sitting on the counter before fruit flies infest your home. This card is a hot-button issue for many couples who often disagree on a standard for “tidy,” so before one of you claims it, get specific about how long you can both live with the toy closet that’s bursting at the seams, all the random crap accumulating under the stairwell, and the donation bags that have been sitting in the trunk of the family car for months.",
      "conception": "Things need to be organized and tidy",
      "planning": [
        {
          "t": "li",
          "text": "Developing a system for organizing your physical home: closets, kitchen/pantry, bedrooms, playroom, office etc. and digital home: organizing computer files in consultation with “Memories & Photos” cardholder"
        },
        {
          "t": "li",
          "text": "Taking stock of what children are currently playing with and what you can donate/ hand down"
        },
        {
          "t": "li",
          "text": "Creating list of donated items and value for tax purposes"
        },
        {
          "t": "li",
          "text": "Researching options for where items will be donated or family/friends to hand down to"
        },
        {
          "t": "li",
          "text": "Identifying storage needs and measuring storage space"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Clearing/wiping counters"
        },
        {
          "t": "li",
          "text": "Putting away toys and shoes"
        },
        {
          "t": "li",
          "text": "Tidying throw blankets and pillows"
        },
        {
          "t": "li",
          "text": "Safely storing important documents, including birth certificates, passports and Social Security cards"
        },
        {
          "t": "li",
          "text": "Gathering items to be donated from “Clothes & Accessories (kids)” and “Wardrobe” cardholders"
        },
        {
          "t": "li",
          "text": "Dropping off donations"
        },
        {
          "t": "li",
          "text": "Purchasing storage and organizational containers"
        },
        {
          "t": "li",
          "text": "Putting together/building storage container"
        }
      ],
      "msc": "Does every item in your home have a proper place and is there a system to get them there? Are those that don’t get donated?",
      "resources": []
    },
    {
      "id": "auto",
      "slug": "auto",
      "sourceId": 26,
      "suit": "out",
      "name": "Auto",
      "fullName": "Auto",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 230,
      "definition": "Do you know what happens if you don’t put the new registration sticker on your car? You get a ticket that could have easily been avoided, that’s what. This cardholder handles all items relating to your family’s car(s), including putting that sticker on in a timely manner, paying for that darn ticket, renewing insurance, handling maintenance, getting car washes, regularly filling up with gas, and getting the oil checked so that you feel safe and secure in the family car.",
      "conception": "We have a car",
      "planning": [
        {
          "t": "li",
          "text": "Researching cars to lease or buy (for budget, functionality, safety, look)"
        },
        {
          "t": "li",
          "text": "Scheduling maintenance (tire maintenance, oil, tune ups, certain mile inspections)"
        },
        {
          "t": "li",
          "text": "Researching auto insurance (consult with “Home Insurance” cardholder about a bundle)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Renewing DMV registration"
        },
        {
          "t": "li",
          "text": "Cleaning (inside and out)"
        },
        {
          "t": "li",
          "text": "Managing inspections"
        },
        {
          "t": "li",
          "text": "Filling gas tank"
        },
        {
          "t": "li",
          "text": "Purchasing auto insurance and renewals"
        }
      ],
      "msc": "Are you driving a car that you feel safe in?",
      "resources": []
    },
    {
      "id": "birthday-celebrations-other-kids",
      "slug": "birthday-celebrations-other-kids",
      "sourceId": 27,
      "suit": "out",
      "name": "Birthday Celebrations (Other Kids)",
      "fullName": "Birthday Celebrations (Other Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 240,
      "definition": "From RSVPing to buying presents, the birthday party circuit for your kids is riddled with opportunities for missteps . . . like when you’re already out the door and realize it’s a princess dress-up theme. Oops. And why didn’t anyone warn you how many weekend hours you’d be spending at other kids’ birthday parties chit-chatting with parents you hardly know? This card pairs with the “transportation (kids)” and “gifts (VIPs)” cards. Meaning, if you RSVP’d yes to the birthday party at the trampoline park, you are responsible for getting your son there (gift in hand) and picking him up afterward.\n\nNote! If you have two or more kids who have to be at separate birthday celebrations, you and your partner can both hold this card separately. A Kid Split means you both CPE the same card at the same time, but for separate kids.",
      "conception": "The kids are invited to a birthday party",
      "planning": [
        {
          "t": "li",
          "text": "RSVPing to invitations (informing “Calendar Keeper” cardholder)"
        },
        {
          "t": "li",
          "text": "Arranging for transportation/attending if younger child"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing stickers/cards, wrapping, gift cards and/or birthday gifts"
        },
        {
          "t": "li",
          "text": "Wrapping gift(s)"
        },
        {
          "t": "li",
          "text": "Filling out facility waivers (e.g., trampoline park)"
        },
        {
          "t": "li",
          "text": "Providing money to child if necessary"
        },
        {
          "t": "li",
          "text": "Attending party if younger child"
        }
      ],
      "msc": "Did you RSVP after consulting with your partner and did your kid get there on time with a gift and enjoy the party?",
      "resources": []
    },
    {
      "id": "calendar-keeper",
      "slug": "calendar-keeper",
      "sourceId": 28,
      "suit": "out",
      "name": "Calendar Keeper",
      "fullName": "Calendar Keeper",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 250,
      "definition": "You know how some business executives have an assistant to schedule all their meetings and events? Well, your family is busier but you have no one. It’s up to you to create a system that works for your family so everyone knows what’s on the calendar day to day and week to week and plans accordingly. Just when you think you’ve nailed the schedule and hung it on the wall, you’ll find out that soccer practice is on the same day as Boy Scouts and you’ll be back to square one. Add in your own commitments along with your spouse’s, and you’ve got a job with more moving parts than a millipede.",
      "conception": "Events need to be managed",
      "planning": [
        {
          "t": "li",
          "text": "Researching how to keep a shared calendar/joint calendar option/app"
        },
        {
          "t": "li",
          "text": "Pick a shared calendar option"
        },
        {
          "t": "li",
          "text": "Conversations/coordinating/tracking invitations with other cardholders"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Adding/deleting appointments"
        },
        {
          "t": "li",
          "text": "Creating kids schedules for helpers with “Childcare Helpers” cardholder"
        }
      ],
      "msc": "Does everyone know where they need to be before they have to be there?",
      "resources": []
    },
    {
      "id": "cash-and-bills",
      "slug": "cash-and-bills",
      "sourceId": 29,
      "suit": "out",
      "name": "Cash & Bills",
      "fullName": "Cash & Bills",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 260,
      "definition": "How darn hard can it be to get to the bank so you have adequate cash on hand (after consulting the “Money Manager,” who can help define the standard for adequate)? Enter this cardholder, who will set up a system that prevents all interested parties from ever uttering or hearing, “Sorry, hon, I’ve only got five bucks.” This CPEer also handles the payment (on time!) of all bills, whether online, checks in the mail, or auto-pay, and balances the checkbook (or the virtual equivalent). Cozy up with the “Mail” cardholder, who will ensure paper bills come your way.",
      "conception": "Bills need to be paid",
      "planning": [
        {
          "t": "li",
          "text": "Set up auto-pay and/or reminders"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Withdrawing cash for the week"
        },
        {
          "t": "li",
          "text": "Paying all bills and vendor invoices (auto pay/electronic, Venmo, checks, cash)"
        },
        {
          "t": "li",
          "text": "Balancing checkbook"
        },
        {
          "t": "li",
          "text": "Doling out children’s allowance"
        }
      ],
      "msc": "Do you have cash when you need it? Were all the bills paid on time with no late fees?",
      "resources": []
    },
    {
      "id": "charity-community-service-and-good-deeds",
      "slug": "charity-community-service-and-good-deeds",
      "sourceId": 30,
      "suit": "out",
      "name": "Charity, Community Service & Good Deeds",
      "fullName": "Charity, Community Service & Good Deeds",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 270,
      "definition": "You want to give back to your community, religious institution, your kids’ schools, or whatever causes are meaningful to you or to others who ask for your support. This cardholder is generous with his or her time (making the meatloaf for the neighborhood meal train) and also your family’s money, so don’t forget to consult the “money manager” before making pledges at the annual school fundraiser you can’t afford.",
      "conception": "You want to give back to the community",
      "planning": [
        {
          "t": "li",
          "text": "Researching charities"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Making donations"
        },
        {
          "t": "li",
          "text": "Volunteering"
        },
        {
          "t": "li",
          "text": "Collecting donations for food banks/Serving on charity boards"
        },
        {
          "t": "li",
          "text": "Meal trains and other community support"
        },
        {
          "t": "li",
          "text": "Visiting the sick"
        }
      ],
      "msc": "Do both partners feel good about your contributions to your community/greater world?",
      "resources": []
    },
    {
      "id": "civic-engagement-and-cultural-enrichment",
      "slug": "civic-engagement-and-cultural-enrichment",
      "sourceId": 31,
      "suit": "out",
      "name": "Civic Engagement & Cultural Enrichment",
      "fullName": "Civic Engagement & Cultural Enrichment",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 280,
      "definition": "Why do all your friends have tickets to the local production of Annie, and you didn’t even know about it? Maybe they had someone to CPE this card . . . and now you will, too. From your city council meetings to concerts to a lecture at the library, this cardholder will take it upon him or herself to research and plan for community events that enhance your family’s life experience. Check in with the “calendar keeper” before you purchase tickets to see your favorite redheaded orphan storm the stage.",
      "conception": "You want to give your family cultural enrichment",
      "planning": [
        {
          "t": "li",
          "text": "Signing up for civic groups and voter registration drives"
        },
        {
          "t": "li",
          "text": "Researching opportunities (subscribing to local community, park, mall, bookstore, library events newsletters/emails/texts)"
        },
        {
          "t": "li",
          "text": "Discussing cultural interests as a family"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Attending meetings of homeowners' association, city council, Neighborhood Watch, etc."
        },
        {
          "t": "li",
          "text": "Purchasing tickets and/or memberships and attending (performing arts, sporting events, concerts, speaker series, museums/art exhibits, movies, comedy shows)"
        }
      ],
      "msc": "Are your kids exposed to new events that enhance their regular life experiences?",
      "resources": []
    },
    {
      "id": "electronics-and-it",
      "slug": "electronics-and-it",
      "sourceId": 32,
      "suit": "out",
      "name": "Electronics & IT",
      "fullName": "Electronics & IT",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 290,
      "definition": "When your cell phone screen shatters, who ya gonna call? This cardholder! When your Wi-Fi isn’t working or your DVR is full, who ya gonna call? This cardholder! You need not work at the cable company or have tech know-how, but you do need to have ample time and patience to CPE this card, especially when you have to wait six hours for the cable guy. New cords, chargers, and ink cartridges? Also you. Waiting in line to get your kid his first phone? Still you.",
      "conception": "Electronics need to be managed",
      "planning": [
        {
          "t": "li",
          "text": "Researching appropriate electronics such as: TV, laptops/computers, tablets/e-readers, video game systems/VR, headphones, surround sound speakers, cell phones, smartwatches, home theater/audio, chargers/cords, home phones"
        },
        {
          "t": "li",
          "text": "Researching and arranging for installation of Wi-Fi"
        },
        {
          "t": "li",
          "text": "Researching password managers"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing electronics"
        },
        {
          "t": "li",
          "text": "Installation management of electronics and cable TV/satellite/boxed TV"
        },
        {
          "t": "li",
          "text": "Electronics troubleshooting and software updating"
        },
        {
          "t": "li",
          "text": "Managing subscriptions (including log in information to various vendors such as cable/satellite TV, boxed TV, subscription television and streaming services)"
        },
        {
          "t": "li",
          "text": "Deleting/managing DVR shows for space storage"
        },
        {
          "t": "li",
          "text": "Wi-Fi/router maintenance and troubleshooting"
        },
        {
          "t": "li",
          "text": "Saving data (USB/cloud storage)"
        }
      ],
      "msc": "Is everything up to do date as needed and working when you need it to be?",
      "resources": []
    },
    {
      "id": "extracurricular-kids-non-sports",
      "slug": "extracurricular-kids-non-sports",
      "sourceId": 33,
      "suit": "out",
      "name": "Extracurricular (Kids; Non-Sports)",
      "fullName": "Extracurricular (Kids; Non-Sports)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 300,
      "definition": "Let’s say your daughter begs to be in the school play—with rehearsals on the same days that she already has Girl Scouts. This cardholder must sleuth out what the extracurricular commitment entails and how to juggle it within the context of the family calendar.\n\nNote! This card pairs with the “transportation (kids)” and “packing (local)” cards. Meaning, if you register your daughter for Girl Scouts and also sign her up for the school play, you are responsible for coordinating how she will get to and from both events with both her costume and cookies in hand.",
      "conception": "Kids extracurricular activities",
      "planning": [
        {
          "t": "li",
          "text": "Determining child's desired activities"
        },
        {
          "t": "li",
          "text": "Researching all activity options (0-2: baby music, gymnastics, and play groups; 2 and up: variety of options)"
        },
        {
          "t": "li",
          "text": "Surveying child's friends to see if child can participate with friends (in consult with “Friendship” cardholder)"
        },
        {
          "t": "li",
          "text": "Determining practice schedules if applicable"
        },
        {
          "t": "li",
          "text": "Managing at home practice and preparation and/or arranging for additional support/coaching (consult with “Tutoring/Coaching” cardholder)"
        },
        {
          "t": "li",
          "text": "Reviewing schedule and consulting with “Calendar Keeper”, “Transportation (kids)”, “Tutoring and Coaching”, and “Showing Up & Participating” cardholders"
        },
        {
          "t": "li",
          "text": "Arranging for transportation"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Signing up and registering for activities"
        },
        {
          "t": "li",
          "text": "Purchasing/storing/updating items for activity"
        },
        {
          "t": "li",
          "text": "Packing necessary items in bag for practice (including water bottle and snacks)"
        },
        {
          "t": "li",
          "text": "Volunteering when necessary (snack sign-up, work backstage, etc.)"
        }
      ],
      "msc": "Are you fostering your goals for your children which may include friendship, life skills, healthy competition, coordination, and brain development? Is it consistent enough for your kid to be enriched by the experience (meaningful exposure) and are they demonstrating improvement?",
      "resources": []
    },
    {
      "id": "extracurricular-kids-sports",
      "slug": "extracurricular-kids-sports",
      "sourceId": 34,
      "suit": "out",
      "name": "Extracurricular (Kids; Sports)",
      "fullName": "Extracurricular (Kids; Sports)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 310,
      "definition": "If you think this card means just showing up on the right field at the right time to cheer on your kid, you couldn’t be more wrong. While the Execution can be rewarding when you’re there to watch your child hit a home run, the Conception and Planning are more tedious and require tremendous forethought. What are the equipment needs? What’s the game schedule? And when do you have to provide the team snack?\n\nNote! This card also pairs with the “Transportation (kids)” and “Packing (local)” cards. Not only are you responsible for making sure the mitt is in the bag, but you’re also on the hook for coordinating how your kid will get to the field on time.",
      "conception": "Kids have extracurricular activities",
      "planning": [
        {
          "t": "li",
          "text": "Determining child's desired activities"
        },
        {
          "t": "li",
          "text": "Researching all sports options (school, gyms and/or community leagues)"
        },
        {
          "t": "li",
          "text": "Surveying child's friends to see if child can play with friends (in consult with “Friendship” cardholder)"
        },
        {
          "t": "li",
          "text": "Determining practice and game schedules"
        },
        {
          "t": "li",
          "text": "Managing at-home practice and preparation and/or arranging for additional support/coaching (consult with “Tutoring/Coaching” cardholder)"
        },
        {
          "t": "li",
          "text": "Researching equipment needs"
        },
        {
          "t": "li",
          "text": "Arranging for transportation to practices and games"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Signing up and registering for the sports lesson/team"
        },
        {
          "t": "li",
          "text": "Purchasing/storing/laundering/updating necessary uniforms/equipment/cleats"
        },
        {
          "t": "li",
          "text": "Packing necessary items in bag for practice and games (including uniform, water bottle, and snacks)"
        },
        {
          "t": "li",
          "text": "Volunteering when necessary (snack sign-up, end-of-season party, etc.)"
        }
      ],
      "msc": "Are you fostering your children's goals, which may include friendship, life skills, healthy competition, coordination, and brain development? Is it consistent enough for your kid to be enriched by the experience (meaningful exposure), and are they demonstrating improvement?",
      "resources": []
    },
    {
      "id": "first-aid-safety-and-emergency",
      "slug": "first-aid-safety-and-emergency",
      "sourceId": 35,
      "suit": "out",
      "name": "First-Aid, Safety & Emergency",
      "fullName": "First-Aid, Safety & Emergency",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 320,
      "definition": "Before bringing home baby from the hospital, this cardholder has installed the infant car seat (yep, it’s a pain, but it’s the law). Before a major storm hits, this cardholder will stock up on batteries, bottled water, and other basics. Does your family have an emergency plan for a time when phones may not work, and you need to leave the house for a safer place? Working flashlights, candles, and matches for when the power is out? Needless to say, this card is a big one and should be taken seriously.",
      "conception": "Your family needs to be safe",
      "planning": [
        {
          "t": "li",
          "text": "Developing emergency list/plan to include contacts, medical directions, home shut off systems etc."
        },
        {
          "t": "li",
          "text": "Researching car seats"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Creating first-aid kit and other supplies, such as extra food/flashlights, etc. for home and car"
        },
        {
          "t": "li",
          "text": "Earthquake-proofing/childproofing home"
        },
        {
          "t": "li",
          "text": "Purchasing and installing car seats"
        }
      ],
      "msc": "Are you sufficiently prepared?",
      "resources": []
    },
    {
      "id": "packing-and-unpacking-kids-local",
      "slug": "packing-and-unpacking-kids-local",
      "sourceId": 36,
      "suit": "out",
      "name": "Packing & Unpacking (Kids; Local)",
      "fullName": "Packing & Unpacking (Kids; Local)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 330,
      "definition": "If you use the last diaper in the baby’s diaper bag and don’t replace it, how many diapers will be left the next time you need to change an explosive poop on the go? Exactly. It’s got to be restocked, just as backpacks need to be packed (and unpacked) daily with library books, lunch, homework, water bottles, clothes for after-school activities, and about a million other things you’ll forget if you don’t have a system in place. Bonus duties: packing for sleepovers, packing and replacing the change of clothes in the school cubby as needed, and hitting up the school’s lost and found when only one glove makes it home.",
      "conception": "Kids need supplies for an activity",
      "planning": [
        {
          "t": "p",
          "text": "BACKPACK AFTERNOON/DAY-OUT BAG"
        },
        {
          "t": "li",
          "text": "Taking inventory of afternoon out bags (water bottle, snacks, sunscreen etc.) SLEEPOVER"
        },
        {
          "t": "li",
          "text": "Determine what is needed for overnight bag (e.g., bathroom bag, clothing, sleeping needs, medical (e.g., Epi-Pen)) *Note: If it is a birthday celebration sleepover, keep the packing with the “Birthday Celebration (other kids)” cardholder who reads the invitation or coordinate closely."
        }
      ],
      "execution": [
        {
          "t": "p",
          "text": "BACKPACK"
        },
        {
          "t": "li",
          "text": "Backpack packing. including snack, water bottle, lunch box (prepared by “Weekday (School Lunches)” cardholder, homework, library books/textbooks/folders, special items"
        },
        {
          "t": "li",
          "text": "Backpack unpacking including emptying lunch box and placing in sink for “Dishes” cardholder"
        },
        {
          "t": "li",
          "text": "Following up on lost items/lost and found AFTERNOON/DAY-OUT BAG"
        },
        {
          "t": "li",
          "text": "Stocking afternoon out bags SLEEPOVER"
        },
        {
          "t": "li",
          "text": "Overnight bag packing and unpacking"
        }
      ],
      "msc": "Do the bags contain what they need at the times you use them? Are they unpacked in a timely manner?",
      "resources": []
    },
    {
      "id": "packing-and-unpacking-travel",
      "slug": "packing-and-unpacking-travel",
      "sourceId": 37,
      "suit": "out",
      "name": "Packing & Unpacking (Travel)",
      "fullName": "Packing & Unpacking (Travel)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 340,
      "definition": "You’re not alone if packing for a trip with kids leaves you questioning if it’s worth going on the trip at all. It feels like moving the army, only your troops may be too young to pack and carry their own gear. Rookie mistake if just before takeoff you discover the iPad battery is at 1 percent.",
      "conception": "Items are needed for travel",
      "planning": [
        {
          "t": "li",
          "text": "Creating a packing list, including “morning of” travel packing list (e.g., snacks, fully charged electronics, headphones, sleep accessories)"
        },
        {
          "t": "li",
          "text": "Packing list considerations: weather forecast and laundry opportunities"
        },
        {
          "t": "li",
          "text": "Determining suitcase needs and purchase when necessary (sharing/individual)"
        },
        {
          "t": "li",
          "text": "Downloading, reading, and managing sleepaway camp packing list (if applicable)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing items needed"
        },
        {
          "t": "li",
          "text": "Actual packing"
        },
        {
          "t": "li",
          "text": "Updating addresses on luggage tags"
        },
        {
          "t": "li",
          "text": "Charging all electronics before flying"
        },
        {
          "t": "li",
          "text": "Getting children involved in packing carry-on items, special items/loveys, medicine"
        },
        {
          "t": "li",
          "text": "For sleepaway camp and extended travel: ordering labels/Sharpie and labeling clothing with children’s names"
        },
        {
          "t": "li",
          "text": "Printing or downloading tickets; making sure everyone who needs an ID has one"
        },
        {
          "t": "li",
          "text": "Filling car with gas if a road trip"
        }
      ],
      "msc": "Sure a forgotten item is common but is everything in the bags that you need or are you stuck purchasing items in a pinch on the road?",
      "resources": []
    },
    {
      "id": "points-miles-and-coupons",
      "slug": "points-miles-and-coupons",
      "sourceId": 38,
      "suit": "out",
      "name": "Points, Miles & Coupons",
      "fullName": "Points, Miles & Coupons",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 350,
      "definition": "Do you know if you have enough airline miles to fly free on your next trip? And also bring your partner along for the ride? This cardholder keeps track of miles, credit card points, coupons, and all those big money savers. Thoughtful CPE of this card is a must—getting that awesome “buy one, get three free” deal only happens when you have your coupon stash organized and in hand at the checkout line.",
      "conception": "Your family has airline miles and coupons",
      "planning": [
        {
          "t": "li",
          "text": "Researching loyalty programs and credit cards"
        },
        {
          "t": "li",
          "text": "Sourcing coupons (online/subscription, store flyers, local newspapers, apps, in mail)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Creating electronic and/or in-home filing system to manage coupons"
        }
      ],
      "msc": "Can you use your miles, points, or coupons because you have the accounts handy and before they expire?",
      "resources": []
    },
    {
      "id": "returns-and-store-credit",
      "slug": "returns-and-store-credit",
      "sourceId": 39,
      "suit": "out",
      "name": "Returns & Store Credit",
      "fullName": "Returns & Store Credit",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 360,
      "definition": "If it seems as if there’s always something you’ve bought that needs to be returned or exchanged—typically without the receipt and on the opposite side of town—then this cardholder will be quite busy. Store credit? Gift cards from your mother-in-law? Sure, they were for your kids, but who’s gonna know if you used one to buy those cute shoes on sale?",
      "conception": "Your family purchases things that might need to be returned",
      "planning": [
        {
          "t": "li",
          "text": "Keeping track of items that need to be returned"
        },
        {
          "t": "li",
          "text": "Figuring out store return policy"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Returning items (within store policy window)"
        },
        {
          "t": "li",
          "text": "Donating or reselling items (if expired)"
        },
        {
          "t": "li",
          "text": "Purchasing items with store credits (within store policy window)"
        },
        {
          "t": "li",
          "text": "Managing gift cards and give to other cardholders such as “Clothes & Accessories (kids)” when appropriate for use"
        }
      ],
      "msc": "Did you return the items during the allotted store policy window? Do you know where your credits are?",
      "resources": []
    },
    {
      "id": "school-breaks-kids-non-summer",
      "slug": "school-breaks-kids-non-summer",
      "sourceId": 40,
      "suit": "out",
      "name": "School Breaks (Kids; Non-Summer)",
      "fullName": "School Breaks (Kids; Non-Summer)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 370,
      "definition": "For your kids’ non-summer vacations like winter and spring break, you have plenty of advance notice to plan. Still, don’t wait too long. The holidays creep up quickly. But when it comes to parent-teacher conferences, school construction, snow days, smoke days, and every other scenario that has you scrambling for childcare, this cardholder must be able to pivot quickly and CPE like a pro.",
      "conception": "Your children have breaks outside of summer",
      "planning": [
        {
          "t": "li",
          "text": "Working in concert with “Childcare Helpers” cardholder to ensure appropriate childcare or camp"
        },
        {
          "t": "li",
          "text": "Planning for childcare/camps/playdates during breaks, half days, and days off"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Hiring (negotiating terms/contract)"
        },
        {
          "t": "li",
          "text": "Ongoing communication and supervision"
        },
        {
          "t": "li",
          "text": "Making payments"
        },
        {
          "t": "li",
          "text": "Purchasing/providing meals and snacks for helper"
        },
        {
          "t": "li",
          "text": "Reimbursing: Gas, meals, and other reimbursements"
        },
        {
          "t": "li",
          "text": "Termination issues"
        }
      ],
      "msc": "Are you prepared in advance for something other than 12 hours of screen time?",
      "resources": []
    },
    {
      "id": "school-breaks-kids-summer",
      "slug": "school-breaks-kids-summer",
      "sourceId": 41,
      "suit": "out",
      "name": "School Breaks (Kids; Summer)",
      "fullName": "School Breaks (Kids; Summer)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 380,
      "definition": "The CPEer of this card may begin researching options for camps or other summer activities months in advance. This workload lasts until the minute all the required forms and fees are taken care of and every day is covered (up to 90 days, but who’s counting?).",
      "conception": "Your children have summer breaks",
      "planning": [
        {
          "t": "li",
          "text": "Determining day camp/sleepaway camp, family travel, summer school, activities/classes or home"
        },
        {
          "t": "li",
          "text": "Researching options for child’s interests, such as sports, theater, art, religion, cooking, science, education, etc., cost and transportation"
        },
        {
          "t": "li",
          "text": "Inquiring/coordinating with friends’ schedules"
        },
        {
          "t": "li",
          "text": "Mapping out each week of summer with “calendar keeper” to determine which activities fit which weeks, not conflicting with trips and other summer events"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Registering for camps"
        },
        {
          "t": "li",
          "text": "Purchasing necessary items for camp (mostly sleepaway)"
        },
        {
          "t": "li",
          "text": "Completing camp forms, including medical history, medication, transportation, medical consent, all about camper, bunk requests, etc."
        }
      ],
      "msc": "Are you prepared in advance for something other than 12 hours of screen time?",
      "resources": []
    },
    {
      "id": "school-forms-kids",
      "slug": "school-forms-kids",
      "sourceId": 42,
      "suit": "out",
      "name": "School Forms (Kids)",
      "fullName": "School Forms (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 390,
      "definition": "Every freakin’ form from school that requires review, including your child’s enrollment forms, notices for overdue library books, and permission slips for field trips, is now in your hands. School forms may come via email (check your spam folder), crumpled up in your child’s backpack, on a school website, or via the school portal, which you’re supposed to know how to log onto and navigate by now, but remains one of life’s mysteries. School forms are enough for this cardholder; direct contact with teachers is the responsibility of the “Teacher Communication” cardholder.",
      "conception": "The school has forms for kids",
      "planning": [
        {
          "t": "li",
          "text": "Coordinate with “Packing & Unpacking (local)” and “Homework, Projects, & School Supplies” cardholders to see if forms come in backpack/homework folder. Forms may include:"
        },
        {
          "t": "li",
          "text": "Back-to-school packets including special instructions, birth certificate, medical forms, including immunization records, allergy notifications (including having third parties sign, such as doctors, etc.)"
        },
        {
          "t": "li",
          "text": "Field trip permission slips"
        },
        {
          "t": "li",
          "text": "Random surveys for class participation/allergy"
        },
        {
          "t": "li",
          "text": "Parent questionnaires"
        },
        {
          "t": "li",
          "text": "School photo order forms"
        },
        {
          "t": "li",
          "text": "Book fair order forms"
        },
        {
          "t": "li",
          "text": "Enrollment contracts"
        },
        {
          "t": "li",
          "text": "Overdue notices for library books"
        },
        {
          "t": "li",
          "text": "Accessing report card through school portal. Exception: School lunch forms go to “Meals (School Lunch)” cardholder"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Managing log in and password for school portal"
        },
        {
          "t": "li",
          "text": "Fill out forms (with child if applicable)"
        }
      ],
      "msc": "Are those forms still crumpled up in the backpack or they filled out on time?",
      "resources": []
    },
    {
      "id": "social-plans-couples",
      "slug": "social-plans-couples",
      "sourceId": 43,
      "suit": "out",
      "name": "Social Plans (Couples)",
      "fullName": "Social Plans (Couples)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 400,
      "definition": "In theory, it’s as simple as texting your friends to get together, picking a date/time/place, and showing up. But that’s not how it works in real life, and certainly not how it works after having kids. For starters, you want your partner’s buy-in for who you’re getting together with, and you’ll need to get a babysitter, so consult with the “Childcare Helpers” cardholder. Then, syncing calendars (pre-bedtime? after the championship game?) will make you question if it’s really worth the effort. If you actually make it out the door without cancelling, you have earned a bonus cocktail.",
      "conception": "You want to be social with your partner",
      "planning": [
        {
          "t": "li",
          "text": "RSVPing to party/night out invitations"
        },
        {
          "t": "li",
          "text": "Discussing with partner who you both would like to see"
        },
        {
          "t": "li",
          "text": "Reaching out to friends/colleagues seeking plans"
        },
        {
          "t": "li",
          "text": "Coordinating schedules"
        },
        {
          "t": "li",
          "text": "Determining restaurant/event interest"
        },
        {
          "t": "li",
          "text": "Designating alcohol-free driver or calling an Uber"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Working with “Childcare Helpers” cardholder to confirm babysitter"
        },
        {
          "t": "li",
          "text": "Making reservations"
        },
        {
          "t": "li",
          "text": "Purchasing tickets to events"
        }
      ],
      "msc": "While there may be one more extroverted partner, is it reasonable to expect to socialize with other couples on occasion? Try to agree to a mutual comfort.",
      "resources": []
    },
    {
      "id": "transportation-kids",
      "slug": "transportation-kids",
      "sourceId": 44,
      "suit": "out",
      "name": "Transportation (Kids)",
      "fullName": "Transportation (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 410,
      "definition": "Full. Time. Job. Whether your kids take a bus, carpool, walk, or have a chauffeur (aka you), managing their transportation can be a beast. On any given day, you could be spending countless hours transporting your kids to school or coordinating with those who are pitching in with drop-offs and pickups. Add on getting them to and from playdates, after-school activities, camp, and every other place they need to be seven days a week, and we’ve come full circle: Full. Time. Job.\n\nNote! The “Transportation (kids)” card pairs with “Birthday Celebrations (other kids),” “Friendships and Social media (kids),” “Extracurricular (non-sports),” and “Extracurricular (sports).” Meaning, if you hold any of the aforementioned cards and they involve giving your kid a ride, you are responsible for transporting or arranging for transportation to and from those activities.",
      "conception": "Your kids need transport",
      "planning": [
        {
          "t": "li",
          "text": "Coordinating and implementing the commute to/from school, extracurricular activities, enrichment, events, playdates, parties"
        },
        {
          "t": "li",
          "text": "If school bus, signing up for appropriate route"
        },
        {
          "t": "li",
          "text": "If public transportation, securing bus/subway pass"
        },
        {
          "t": "li",
          "text": "If carpool, extra considerations: selecting families that live nearby to carpool with (coordinate booster/car seats); determining schedule for your shift and others’"
        },
        {
          "t": "li",
          "text": "Finalizing daily schedule with “calendar keeper”"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Implementing the commute to/from school, extracurricular activities, enrichment, events, playdates, parties"
        }
      ],
      "msc": "Are the children where they need to be and picked up on time?",
      "resources": []
    },
    {
      "id": "travel",
      "slug": "travel",
      "sourceId": 45,
      "suit": "out",
      "name": "Travel",
      "fullName": "Travel",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 420,
      "definition": "When you’re thinking about taking a trip, the who/where/ when/how formula has endless permutations. If you add in any extended family, best of luck as you navigate how to get everyone to the same place at the same time on a budget, where hopefully fun awaits. Even a day trip for a friend’s wedding requires someone to handle logistics, so just because you’re not jet-setting to a white sand beach doesn’t mean you’re off the hook from CPEing this card.\n\nTip! Work closely with the “Packing & Unpacking (Travel)” cardholder to ensure that once you get to your destination, you have the appropriate clothes and amenities in your suitcase.",
      "conception": "You want to travel",
      "planning": [
        {
          "t": "li",
          "text": "Sourcing vacation ideas (adult only or family, warm or cold climate, relaxation or adventure, domestic or international)"
        },
        {
          "t": "li",
          "text": "Researching potential destinations, including airfare, hotel, transportation, activities, dining, health or other travel alerts"
        },
        {
          "t": "li",
          "text": "Securing/renewing/checking expiration for everyone’s passports"
        },
        {
          "t": "li",
          "text": "Discussing how much vacation time can be used from work"
        },
        {
          "t": "li",
          "text": "Selecting dates for travel (that work for everyone, including kids in school)"
        },
        {
          "t": "li",
          "text": "Calling hotel concierge for dining/activity recommendations"
        },
        {
          "t": "li",
          "text": "Researching (asking friends, internet, books) activities and dining out"
        },
        {
          "t": "li",
          "text": "Working with “Points, Miles, & Coupons” cardholder to redeem miles"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Checking in to flights"
        },
        {
          "t": "li",
          "text": "Making flight/hotel/rental car (car seats, if necessary) reservations and confirming prior to travel"
        },
        {
          "t": "li",
          "text": "Purchasing travel insurance"
        },
        {
          "t": "li",
          "text": "Making reservations for activities and dining out"
        }
      ],
      "msc": "Did everyone get to where they were supposed to be without unreasonable stress?",
      "resources": []
    },
    {
      "id": "tutoring-and-coaching",
      "slug": "tutoring-and-coaching",
      "sourceId": 46,
      "suit": "out",
      "name": "Tutoring & Coaching",
      "fullName": "Tutoring & Coaching",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 430,
      "definition": "Take this card if you take the lead on extra school enrichment and/or you are the coach of your kids’ Little League teams. Some families utilize school-based options while others pursue tutoring companies outside of school or hire tutors/ coaches for kids’ academics, sports, or special interests like playing a musical instrument. In every case, this cardholder needs to research the options, confirm availability with the “Calendar Keeper,” and assess progress on an ongoing basis. If your kid still can’t hit the ball, it might be time for a new coach . . . or a new sport.",
      "conception": "Your kids need support",
      "planning": [
        {
          "t": "p",
          "text": "TUTORING"
        },
        {
          "t": "li",
          "text": "Evaluating if child needs extra supports (discussing with “Teacher Communication” cardholder)"
        },
        {
          "t": "li",
          "text": "Researching school-based options for additional support"
        },
        {
          "t": "li",
          "text": "Researching/scheduling a consistent time to conduct enrichment/determining if you practice or reinforce with child COACHING"
        },
        {
          "t": "li",
          "text": "Appraising child’s/team’s needs (voice, sports etc.)"
        },
        {
          "t": "li",
          "text": "Researching external coaches"
        },
        {
          "t": "li",
          "text": "Reviewing weekend schedule (working with calendar keeper to see what periods of time are open for plans)"
        },
        {
          "t": "li",
          "text": "Checking weather forecast"
        },
        {
          "t": "li",
          "text": "Asking family members for ideas"
        },
        {
          "t": "li",
          "text": "Coordinating with friends and family"
        }
      ],
      "execution": [
        {
          "t": "p",
          "text": "TUTORING"
        },
        {
          "t": "li",
          "text": "Hiring external tutor/signing up for tutoring program/practice or reinforce with child"
        },
        {
          "t": "li",
          "text": "Purchasing school enrichment materials COACHING"
        },
        {
          "t": "li",
          "text": "Hiring external coaches and or/ signing up/registering/conducting your coaching"
        }
      ],
      "msc": "If this card is in play, are you up to date and working on progress you want your child to make?",
      "resources": []
    },
    {
      "id": "weekend-plans",
      "slug": "weekend-plans",
      "sourceId": 47,
      "suit": "out",
      "name": "Weekend Plans",
      "fullName": "Weekend Plans",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 440,
      "definition": "Socializing as a family can check off several boxes, including getting your kids out of the house and off screens, seeing your friends, and your kids seeing their friends. (Lucky for you if you like the parents of your kids’ BFFs.) But all this box checking requires much CPE, so think it through before you offer to organize a picnic in the park for your BFFs and the twenty kids among them.",
      "conception": "You have weekends with your family",
      "planning": [
        {
          "t": "li",
          "text": "Reviewing weekend schedule (working with “Calendar Keeper” cardholder to see what periods of time are open for plans)"
        },
        {
          "t": "li",
          "text": "Checking weather forecast"
        },
        {
          "t": "li",
          "text": "Asking family members for ideas"
        },
        {
          "t": "li",
          "text": "Coordinating with friends and family"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Communicating the plan to your family"
        },
        {
          "t": "li",
          "text": "Executing the plan for the weekend"
        }
      ],
      "msc": "No, twelve hours of screen time is not reasonable, and neither is being so overscheduled you want to scream. Like Goldilocks, do you have plans once the weekend comes that feel just right?",
      "resources": []
    },
    {
      "id": "bathing-and-grooming-kids",
      "slug": "bathing-and-grooming-kids",
      "sourceId": 60,
      "suit": "caregiving",
      "name": "Bathing & Grooming (Kids)",
      "fullName": "Bathing & Grooming (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 450,
      "definition": "The nature of this cardholder’s responsibilities changes depending on your kids’ ages, but the point is that your kids need to brush their teeth, bathe, wash their faces, cut their nails, and brush their hair. Over and over again.\n\nTip! Pay attention to your kids’ developing needs. If you notice a suspicious scent every time your teenager is within five feet, it’s probably time for this CPEer to buy deodorant and make sure your kid knows how often to use it. Daily!",
      "conception": "The kids need to be clean",
      "planning": [
        {
          "t": "li",
          "text": "Scheduling haircuts"
        },
        {
          "t": "li",
          "text": "Monitoring supply of bath products, detangler, scissors, toothbrushes and floss and notifying “Home Goods & Supplies” cardholder"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Carrying out haircuts"
        },
        {
          "t": "li",
          "text": "Managing daily showers/baths including wash/brushing hair/brushing teeth"
        },
        {
          "t": "li",
          "text": "Cutting nails and toenails"
        },
        {
          "t": "li",
          "text": "Boo-boo care"
        },
        {
          "t": "li",
          "text": "Age-appropriate add-ons (e.g., deodorant, period care, razors, lotion, hair dryer, etc.)"
        },
        {
          "t": "li",
          "text": "Conducting lice checks when needed"
        }
      ],
      "msc": "Are your children groomed and presentable to the world? Would you be embarrassed to introduce your child to your boss? (i.e can you smell them from a mile away?)",
      "resources": []
    },
    {
      "id": "bedtime-routine-kids",
      "slug": "bedtime-routine-kids",
      "sourceId": 63,
      "suit": "caregiving",
      "name": "Bedtime Routine (Kids)",
      "fullName": "Bedtime Routine (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 460,
      "definition": "It can be super rewarding when nighttime includes bonding over the day’s events, cuddling like nobody’s business, or lying quietly with your precious child. Not so much when this routine becomes a battle over bedtime. Pleas for just one more glass of water or five more minutes of reading can test your patience and fortitude (no wonder Go the F**k to Sleep is a bestselling book). While one person needs to take the CPE lead, the other is not home free (i.e., this is not an ideal window of time for you to hit the couch and start flipping channels). Your collaboration is encouraged. Try this: One partner holds the “bathing and grooming (kids)” card to get the party started while the other is responsible for jammies, stories, and lights out. Keep in mind that this routine won’t last forever. Before you know it, your babies will be teenagers, and you’ll be going to sleep long before them.",
      "conception": "The kids need to go to sleep",
      "planning": [
        {
          "t": "li",
          "text": "Encouraging reading or quiet activity before bed"
        },
        {
          "t": "li",
          "text": "Coordinating with “Bathing & Grooming (Kids)” cardholder to follow their lead on routine schedule"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Enforcing lights-out policy at particular time"
        },
        {
          "t": "li",
          "text": "Reading with kids"
        },
        {
          "t": "li",
          "text": "Bringing kids to the bathroom"
        },
        {
          "t": "li",
          "text": "Filling bedside water glass"
        }
      ],
      "msc": "Are the kids calm before bed and well-rested?",
      "resources": []
    },
    {
      "id": "clothes-and-accessories-kids",
      "slug": "clothes-and-accessories-kids",
      "sourceId": 65,
      "suit": "caregiving",
      "name": "Clothes & Accessories (Kids)",
      "fullName": "Clothes & Accessories (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 470,
      "definition": "News flash: Your kids’ shoes and clothes—in sizes that fit— don’t magically show up in their closets. Someone needs to CPE what clothes and accessories to buy, get to the appropriate stores, clean out drawers periodically, and hand off used and outgrown clothes to the “Tidying Up, Organizing, & Donations” cardholder. Suggested timeline: If your child’s feet have blisters, you’ve probably waited too long to buy new shoes. Exception: If there is a camp or school one-off clothing need, this responsibility stays with the “School Breaks (Summer)” or “Homework” cardholder.",
      "conception": "The kids need clothes",
      "planning": [
        {
          "t": "li",
          "text": "Sorting through child's current wardrobe"
        },
        {
          "t": "li",
          "text": "Determining which clothes still fit and which they have outgrown"
        },
        {
          "t": "li",
          "text": "Creating a list of clothing needs whether it be seasonal or by occasion or age (e.g., bras)"
        },
        {
          "t": "li",
          "text": "Evaluating underwear, socks, shoes, and accessories"
        },
        {
          "t": "li",
          "text": "Arranging for try-on time"
        },
        {
          "t": "li",
          "text": "Coordinating with “Returns & Store Credits” cardholder if needed."
        },
        {
          "t": "p",
          "text": "Exception: clothes for special school days responsibility of “Homework, Projects, & School Supplies” cardholder"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Donating or passing on those items they have outgrown to other children"
        },
        {
          "t": "li",
          "text": "Shopping for items in store or online"
        }
      ],
      "msc": "Are there appropriate seasonal clothes available to the children when they need them? (i.e., winter coat available before the snow comes)",
      "resources": []
    },
    {
      "id": "dental-kids",
      "slug": "dental-kids",
      "sourceId": 66,
      "suit": "caregiving",
      "name": "Dental (Kids)",
      "fullName": "Dental (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 480,
      "definition": "Your kid’s job: Pick out a rubber band color for his braces. Your job: Carve out a boatload of time for orthodontist appointments and pay for it all, too. Regular dental visits will also keep you plenty busy because each child needs regular cleanings and checkups (it’s been six months already?) along with more time-consuming appointments for getting cavities filled. You get a free toothbrush at the end of each visit, so at least there’s that.",
      "conception": "The kids have teeth",
      "planning": [
        {
          "t": "li",
          "text": "Researching and selecting dentist"
        },
        {
          "t": "li",
          "text": "Scheduling bi-annual dental cleanings"
        },
        {
          "t": "li",
          "text": "Informing “Bedtime Routine” cardholder about appropriate daily dental hygiene"
        },
        {
          "t": "li",
          "text": "Checking on toothbrush and toothpaste for when to replace and informing “Home Goods & Supplies” cardholder"
        },
        {
          "t": "li",
          "text": "Orthodontist visits if applicable"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Attending dentist appointments"
        },
        {
          "t": "li",
          "text": "Following up with specialists like orthodontists"
        },
        {
          "t": "li",
          "text": "At-home orthodontic care (purchase and application of rubber bands, headgear etc.)"
        }
      ],
      "msc": "Are your children at the dentist with a protocol of every six-month visit and do you follow up on the dentists advice?",
      "resources": []
    },
    {
      "id": "diapering-and-potty-training-kids",
      "slug": "diapering-and-potty-training-kids",
      "sourceId": 67,
      "suit": "caregiving",
      "name": "Diapering & Potty Training (Kids)",
      "fullName": "Diapering & Potty Training (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 490,
      "definition": "Let’s be clear: This cardholder will not be the only one changing diapers. Expect to re-deal this card often. While you are the lead, you will, however, be the one responsible for maintaining inventory, including ordering new diapers or washing cloth ones, and getting the soiled ones out of your house ASAP. This cardholder will also oversee potty training your kids, including cleaning up the mistakes along the way. When you’re finally a diaper-free home, you may still find yourself wiping the butt of your first grader, who is perfectly capable of doing it on his or her own. This will end one day—promise.",
      "conception": "The kids need bathroom support",
      "planning": [
        {
          "t": "li",
          "text": "Determining diapering options (disposable brands or cloth)"
        },
        {
          "t": "li",
          "text": "Taking inventory of diaper bags (wipes, diapers, creams, changing pad, pacifiers, extra change of clothes, loveys, toys, books, etc.)"
        },
        {
          "t": "li",
          "text": "Researching, consulting with partner regarding training plan"
        },
        {
          "t": "li",
          "text": "Informing and enlisting teachers and childcare helpers in potty-training plan"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing appropriately sized diapers/wipes as baby grows (or coordinating with “Home Goods & Supplies” cardholder)"
        },
        {
          "t": "li",
          "text": "Stocking diaper bags"
        },
        {
          "t": "li",
          "text": "Overseeing implementation for potty training"
        }
      ],
      "msc": "It should be dealt with proactively, so are you in a rash-free, smell-free home? (i.e, are the crystals falling out? WTF are those things?)",
      "resources": []
    },
    {
      "id": "estate-planning-and-life-insurance",
      "slug": "estate-planning-and-life-insurance",
      "sourceId": 68,
      "suit": "caregiving",
      "name": "Estate Planning & Life Insurance",
      "fullName": "Estate Planning & Life Insurance",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 500,
      "definition": "Who will take care of your kids if something catastrophic happens to you and your partner? Of course both partners will plan together as you think about long-term security for your family and life-and-death medical decisions, but ultimately this cardholder is responsible for making sure the job gets done so you can all sleep at night knowing there’s a worst-case scenario plan (and insurance funds) in place.",
      "conception": "Estate Planning & Life Insurance is needed",
      "planning": [
        {
          "t": "li",
          "text": "Researching attorney/insurance agent or online service"
        },
        {
          "t": "li",
          "text": "Selecting and informing childcare custodian"
        },
        {
          "t": "li",
          "text": "Researching appropriate life insurance (term, whole life, etc.)"
        },
        {
          "t": "li",
          "text": "Researching appropriate disability insurance"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Meeting with attorney to set plan or fill out forms online regarding will/trust, power of attorney, healthcare directive, guardianship designation"
        },
        {
          "t": "li",
          "text": "Purchasing insurance policy"
        }
      ],
      "msc": "Does the plan reflect your current family circumstances and is it legally binding and effective?",
      "resources": []
    },
    {
      "id": "family-planning-birth-control",
      "slug": "family-planning-birth-control",
      "sourceId": 64,
      "suit": "caregiving",
      "name": "Family Planning / Birth Control",
      "fullName": "Family Planning / Birth Control",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 510,
      "definition": "Why is this a separate card instead of being a component of self-care or medical? Because the woman should not be the she-fault cardholder, meaning either of you can claim this card. If having a baby is not on you and your partner’s agenda, this cardholder will research contraception options, which may include buying condoms, the pill, an IUD, or scheduling a vasectomy. (Not sure if being too tired to have sex at all is considered a form of birth control? Ask around.)\n\nOn the other hand, if you are hoping to grow your family, this cardholder might schedule a preconception check-up, start tracking cycles, research fertility apps, or look into prenatal vitamins and lifestyle adjustments that support conception. They may also explore options for fertility support or talk through timelines and next steps with your partner.",
      "conception": "Planning for a baby or birth control is needed",
      "planning": [
        {
          "t": "li",
          "text": "Researching options (vasectomy, pill/IUD, condoms, etc.)"
        },
        {
          "t": "li",
          "text": "Research options (fertility apps, prenatal vitamins, lifestyle adjustments, etc.)"
        },
        {
          "t": "li",
          "text": "Scheduling doctor appointment(s), if applicable"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Implementing plan"
        }
      ],
      "msc": "Are you protected from getting pregnant? / Do you feel prepared to start trying to have a baby?",
      "resources": []
    },
    {
      "id": "friendship-and-social-media-kids",
      "slug": "friendship-and-social-media-kids",
      "sourceId": 69,
      "suit": "caregiving",
      "name": "Friendship & Social Media (Kids)",
      "fullName": "Friendship & Social Media (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 520,
      "definition": "Do you know who your kids are playing with IRL and online? Unless your children come home from school in tears confiding in you, how would you know if they’re hanging with the wrong crowd, feeling left out, or being bullied? Make it your business to plug in (get it?) to your kids’ social dynamics online and also help plan and supervise playdates, sleepovers, and any other kid get-togethers.",
      "conception": "The kids need friends",
      "planning": [
        {
          "t": "li",
          "text": "Friendship detective questions (evaluating child’s social situation to see if they are making connections with others, that is, asking appropriate questions of child: who they play with at recess, who they sit with at lunch etc., is anyone bullying them at school, are they confident in who they are spending their time with)"
        },
        {
          "t": "li",
          "text": "Discussing friend situation with child at start of school year and working with “Teacher Communication” cardholder on any issues"
        },
        {
          "t": "li",
          "text": "Planning and scheduling sleepovers, outings, play dates with friends"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Carrying out sleepovers, outings, play dates with friends"
        },
        {
          "t": "li",
          "text": "Monitoring and regulating social media accounts in coordination with “Discipline & Screen” time cardholder"
        }
      ],
      "msc": "Are they appropriately socialized in real life? Do you feel in control of their social media?",
      "resources": []
    },
    {
      "id": "grooming-and-wardrobe-player-1",
      "slug": "grooming-and-wardrobe-player-1",
      "sourceId": 61,
      "suit": "caregiving",
      "name": "Grooming & Wardrobe",
      "fullName": "Grooming & Wardrobe (Player 1)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": true,
      "playerSlot": 1,
      "pairKey": "grooming-and-wardrobe",
      "kids": false,
      "sortOrder": 530,
      "definition": "Looking and feeling good, especially after children, doesn’t come easy. (There’s a reason that beauty is a $445 billion industry.) Even if you’re a DIY kind of woman, it still takes time to slather on moisturizer, pluck your eyebrows, style your hair, and put on lipstick. Kick it up a notch and you may add mani/pedis, eyelash extensions, and waxing to your beauty regimen. Add in shopping for clothes (in various sizes for pre-pregnancy, post-pregnancy, nursing, and every other reason your weight fluctuates) and you’ve got a potentially expensive and time-consuming card in your hands.",
      "conception": "You need to be presentable",
      "planning": [
        {
          "t": "p",
          "text": "INSOURCED"
        },
        {
          "t": "li",
          "text": "Purchasing all necessary beauty products and tools, including makeup (lipstick, powder, mascara, eye liner/shadow, foundation, eyebrow liner) tweezers, deodorant, moisturizers/lotions/anti-aging creams, makeup removers, hairspray, gel, mousse, etc., hair accessories, nail polish, nail kit (nail files, cuticle scissors, buffers, etc.), hair dye"
        }
      ],
      "execution": [
        {
          "t": "p",
          "text": "INSOURCED"
        },
        {
          "t": "li",
          "text": "Applying/using all necessary beauty products and tools"
        },
        {
          "t": "p",
          "text": "OUTSOURCED"
        },
        {
          "t": "li",
          "text": "Hair removal appointments"
        },
        {
          "t": "li",
          "text": "Haircut/blow-dry/color/highlights/straightening/extensions (hair, lashes)"
        },
        {
          "t": "li",
          "text": "Nail appointments"
        },
        {
          "t": "li",
          "text": "Facials/injection appointments"
        },
        {
          "t": "li",
          "text": "Tattoos"
        },
        {
          "t": "li",
          "text": "Piercings"
        }
      ],
      "msc": "Are you in charge of your own clothes and do you have appropriate clothes for all occasions? Do you feel good about yourself based on your expectations? Can you handle this yourself and not ask your partner to do it for you?",
      "resources": []
    },
    {
      "id": "grooming-and-wardrobe-player-2",
      "slug": "grooming-and-wardrobe-player-2",
      "sourceId": 62,
      "suit": "caregiving",
      "name": "Grooming & Wardrobe",
      "fullName": "Grooming & Wardrobe (Player 2)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": true,
      "playerSlot": 2,
      "pairKey": "grooming-and-wardrobe",
      "kids": false,
      "sortOrder": 540,
      "definition": "Imagine a conversation that starts innocently enough with a husband asking his wife, “Babe, where’s my black suit?” Then comes, “Never mind. Found it.” (Pause.) “Shoot, it doesn’t fit anymore.” And the coup de grâce is that their best friends’ wedding begins in one hour, and the clock is ticking while he blames his wife for failing to buy or rent him a new one. This scenario is all too common, as many women in hetero cis gender relationships CPE this card for their husbands. That’s right, grown men told me they rely on their wives not only to help them get dressed for special events but also to schedule haircuts, hem their pants, and replace their underwear with holes. If that truly works for you both, God bless. Otherwise, please consider taking this card for yourself, mister. You can do it.",
      "conception": "You need to be presentable",
      "planning": [
        {
          "t": "li",
          "text": "Looking through own current wardrobe"
        },
        {
          "t": "li",
          "text": "Determining which clothes still fit and which might be outdated or worn out"
        },
        {
          "t": "li",
          "text": "Creating a list of clothing needs whether it be seasonal or by occasion"
        },
        {
          "t": "li",
          "text": "Evaluating underwear, socks, shoes, belts, and other accessories"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Donating wrong size, outdated, worn-out items"
        },
        {
          "t": "li",
          "text": "Shopping for necessary items"
        }
      ],
      "msc": "Are you in charge of your own clothes and do you have appropriate clothes for all occasions? Do you feel good about yourself based on your expectations? Can you handle this yourself and not ask your partner to do it for you?",
      "resources": []
    },
    {
      "id": "health-insurance",
      "slug": "health-insurance",
      "sourceId": 70,
      "suit": "caregiving",
      "name": "Health Insurance",
      "fullName": "Health Insurance",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 550,
      "definition": "It’s a blessing to have health insurance. The paperwork that goes along with it? Not so much. Unless you somehow find a medical practice that handles all the billing for you, this cardholder needs to know every time anyone in your family goes to the doctor, makes sure the appropriate paperwork is filed for insurance, keeps track of reimbursements, and steps in when things go awry. Every time you see an envelope from your insurance provider (consult with the “Mail” cardholder to ensure you receive it), say a prayer that you’ve been covered.",
      "conception": "The family needs health insurance",
      "planning": [
        {
          "t": "li",
          "text": "Determining health insurance options (work, exchange etc.)"
        },
        {
          "t": "li",
          "text": "Researching various plans (HMO, PPO, etc.) to determine if doctors, specialists, prescriptions, other special needs are covered"
        },
        {
          "t": "li",
          "text": "Establishing flexible spending plan/health savings account if appropriate"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Selecting and enrolling in plan during open enrollment window"
        },
        {
          "t": "li",
          "text": "Fighting for coverage/reimbursement from medical providers"
        },
        {
          "t": "li",
          "text": "Giving checks to “Money Manager” cardholder for deposit in bank account"
        },
        {
          "t": "li",
          "text": "Checking whether deductible is being met"
        }
      ],
      "msc": "If you are lucky enough to have health insurance, are your co-pays up to date and are you reimbursed in a timely manner?",
      "resources": []
    },
    {
      "id": "homework-projects-and-school-supplies-kids",
      "slug": "homework-projects-and-school-supplies-kids",
      "sourceId": 71,
      "suit": "caregiving",
      "name": "Homework, Projects & School Supplies (Kids)",
      "fullName": "Homework, Projects & School Supplies (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 560,
      "definition": "Has homework become a family affair? Even if you swore you’d never be the kind of parent who micromanages and digs in to your kids’ assignments, you at least need to be in the know if they don’t do their homework and be available if your child needs support. CPEing this card means not only taking the lead on daily assignments but also school projects and enrichment learning at home. If A child needs poster board for “Star Student of the Week” or munchies for “Snack Day,” that’s also on you, as well as outfitting your child for “Wacky Winter” dress-up day and providing two dozen (hand-signed!) Valentine’s Day cards on February 14. This is an endless job, so re-deal this card often.",
      "conception": "The kids have school",
      "planning": [
        {
          "t": "li",
          "text": "Supervising welcome-to-school assignments (e.g., photos of my family)"
        },
        {
          "t": "li",
          "text": "Assessing child’s daily/weekly homework needs"
        },
        {
          "t": "li",
          "text": "Helping child prioritize what needs to be done based on after-school activity schedule"
        },
        {
          "t": "li",
          "text": "Updating “Calendar Keeper” & “School Breaks” cardholders on all important school dates including fall school recess, half days, conference weeks, winter break"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Assisting child when needed and providing emotional support when homework is challenging"
        },
        {
          "t": "li",
          "text": "Assisting child with studying for tests"
        },
        {
          "t": "li",
          "text": "Supporting and purchasing supplies for major projects (science fair, school biography, secret buddy gifts, Valentines, etc.)"
        },
        {
          "t": "li",
          "text": "Purchasing/arranging clothes for special days (e.g., school photos, performance concerts, field day, color wars, school theme days) and consulting with “Morning Routine” cardholder"
        },
        {
          "t": "li",
          "text": "Ordering school uniform if applicable"
        },
        {
          "t": "li",
          "text": "Ordering/shopping for back-to-school supplies"
        }
      ],
      "msc": "Are the kids supported enough so that they can turn their homework in on time?",
      "resources": []
    },
    {
      "id": "medical-and-healthy-living-kids",
      "slug": "medical-and-healthy-living-kids",
      "sourceId": 72,
      "suit": "caregiving",
      "name": "Medical & Healthy Living (Kids)",
      "fullName": "Medical & Healthy Living (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 570,
      "definition": "From stocking up on standard pain relievers and regular checkups at the pediatrician to seeing specialists as needed, your kids’ medical care requires tremendous research, coordination, and time. Healthy living may also include buying vitamins and healthy snacks (in collaboration with the “Groceries” cardholder) and inspiring an active lifestyle with family exercise or other heart-pumping activities. This cardholder also takes the lead, stocking up on items like hand sanitizer, sunscreen, and bug spray. Exception: You’re off the hook from dealing with “health insurance” unless that’s your card, too.",
      "conception": "The kids need to be healthy",
      "planning": [
        {
          "t": "li",
          "text": "Researching, interviewing and selecting pediatrician"
        },
        {
          "t": "li",
          "text": "Scheduling well checks, vaccine appointments, & annual physicals"
        },
        {
          "t": "li",
          "text": "Ensuring that child has up-to-date vaccines"
        },
        {
          "t": "li",
          "text": "Keeping track of questions to ask doctor between well visits"
        },
        {
          "t": "li",
          "text": "Scheduling child’s sick visits"
        },
        {
          "t": "li",
          "text": "Determining if specialists are necessary (e.g., eye doctor, GI etc.)"
        },
        {
          "t": "li",
          "text": "Prevention: researching vitamins & sunscreen (for “Morning Routine” cardholder)"
        },
        {
          "t": "li",
          "text": "Encouraging active lifestyle for all family members, especially exercise"
        },
        {
          "t": "li",
          "text": "Ensuring that “Groceries” cardholder is including plenty of healthy food options for adults and children"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing and stocking standard pain reliever/allergy medicines for children (and adults whenever possible)"
        },
        {
          "t": "li",
          "text": "Keeping specialty medicine up to date, including specialty items like EpiPen and asthma medications/nebulizers"
        },
        {
          "t": "li",
          "text": "Attending and taking notes during well checks, vaccine appointments, and annual physicals"
        },
        {
          "t": "li",
          "text": "Attending child’s sick visits"
        },
        {
          "t": "li",
          "text": "Filling prescriptions, checking medicine side effects and administering medicine"
        },
        {
          "t": "li",
          "text": "Manage at-home medical issues such as constipation, sleeping issues, allergies, other GI, asthma, ENT, etc."
        },
        {
          "t": "li",
          "text": "Purchasing vitamins and sunscreen"
        },
        {
          "t": "li",
          "text": "Monitoring family members’ consumption of caffeine, alcohol, fried foods, smoking habits, fatty foods"
        },
        {
          "t": "li",
          "text": "Encouraging calming behaviors/quiet times"
        }
      ],
      "msc": "Are you on top of your kids' health concerns, and do they go to their physicals on time?",
      "resources": []
    },
    {
      "id": "morning-routine",
      "slug": "morning-routine",
      "sourceId": 73,
      "suit": "caregiving",
      "name": "Morning Routine",
      "fullName": "Morning Routine",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 580,
      "definition": "When was the last time you slept in, pooped in peace, or leisurely read the newspaper while drinking coffee in the morning? Before kids, if you’re holding this card. This cardholder is prepared for daily combat before sunrise with a baby and early still with school-aged kids who often need rousing from bed and help getting dressed, hair and teeth brushed, sunscreen applied, and ushering out the door. At least the “Meals (Weekday Breakfast)” cardholder takes the lead on getting them fed.",
      "conception": "The kids need to be ready in the morning",
      "planning": [
        {
          "t": "li",
          "text": "Ensuring children are up and getting ready for the day (dressed in appropriate, seasonal clothes, hair/teeth brushed, bathroom needs met)"
        },
        {
          "t": "li",
          "text": "Consulting with “Homework, Projects, & School Supplies” cardholder for special clothes days"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Applying sunscreen"
        },
        {
          "t": "li",
          "text": "Taking vitamins/medicines"
        }
      ],
      "msc": "Are the kids appropriately hygienic and dressed for school? (i.e., when it’s 20 degrees out, shorts don’t cut it)",
      "resources": []
    },
    {
      "id": "parents-and-in-laws",
      "slug": "parents-and-in-laws",
      "sourceId": 74,
      "suit": "caregiving",
      "name": "Parents & In-Laws",
      "fullName": "Parents & In-Laws",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 590,
      "definition": "Whether your parents and/or in-laws live nearby or thousands of miles away, it’s a relationship that can require a fair amount of TLC and CPE. Someone’s got to call them regularly, help them figure out how to turn on their TV with one of their 100-year-old remotes, and invite them to holiday or birthday celebrations. (Or maybe not.)",
      "conception": "You have parents/ in-laws",
      "planning": [
        {
          "t": "li",
          "text": "Plan for parent/in-law engagement"
        },
        {
          "t": "li",
          "text": "Calling/arranging for visits and visiting parents and in-laws an adequate amount (consult with “Travel” cardholder)"
        },
        {
          "t": "li",
          "text": "Becoming familiar with parents’/in-laws’ health, including medical history, current medical issues, financial or other concerns"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing and have family members sign or decorate cards for important occasions (birthday, holiday, Mother’s/Father’s Day)"
        },
        {
          "t": "li",
          "text": "Handling parents/in-laws needs during their visits, including airport transportation, activity/meal planning, taking vacation days to spend time with them"
        },
        {
          "t": "li",
          "text": "Managing parents’/in-laws’ wishes for burial while alive"
        },
        {
          "t": "li",
          "text": "Educating on electronics/IT/other current issues"
        }
      ],
      "msc": "Do you agree on the role parents/in-laws have in your life? If not, can you agree on a reasonable role going forward?",
      "resources": []
    },
    {
      "id": "pets",
      "slug": "pets",
      "sourceId": 75,
      "suit": "caregiving",
      "name": "Pets",
      "fullName": "Pets",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 600,
      "definition": "When you got your pet, the deal was that the kids would take on a lot of the responsibility. Ha! Now, here you are with a bundle of furry love . . . and a bundle of work. Your to-do list depends on what kind of animal you have, but across the board this cardholder typically CPEs food, veterinary appointments, grooming, pet supplies, finding a pet sitter for when you’re away, and the least fun but most important—taking out the kitty litter or being on the ready with poop bag in hand.",
      "conception": "The kids need to be healthy",
      "planning": [
        {
          "t": "li",
          "text": "Researching pet type/breed"
        },
        {
          "t": "li",
          "text": "Finding breeder/rescue/shelter, researching with breeder/shelter & communication"
        },
        {
          "t": "li",
          "text": "Animal proofing if needed"
        },
        {
          "t": "li",
          "text": "Researching & interviewing veterinarian"
        },
        {
          "t": "li",
          "text": "Arranging for receiving pet"
        },
        {
          "t": "li",
          "text": "Handling vet checkup appointments (e.g. necessary shots, spayed/neutered, nails, clipping, health concerns, medicine)"
        },
        {
          "t": "li",
          "text": "Finding a groomer & scheduling grooming appointments"
        },
        {
          "t": "li",
          "text": "Determining if it makes sense to purchase pet insurance & researching insurance plans"
        },
        {
          "t": "li",
          "text": "Handling vet sick appointments"
        },
        {
          "t": "li",
          "text": "Securing care during out-of-town travel/away times including researching options/ interviewing person or viewing facility"
        },
        {
          "t": "li",
          "text": "Hair pick up issues (researching vacuum options etc.)"
        },
        {
          "t": "li",
          "text": "Arranging for special outside access (e.g. dog door)"
        },
        {
          "t": "li",
          "text": "Researching & purchasing appropriate food"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Receiving pet"
        },
        {
          "t": "li",
          "text": "Purchasing food and treats and other necessary items (e.g. grooming items, bedding, crate, harness, litter"
        },
        {
          "t": "li",
          "text": "Training (bathroom, sleeping, biting and introduction to babies/children)"
        },
        {
          "t": "li",
          "text": "Feeding: Providing food and water daily and keeping bowls clean"
        },
        {
          "t": "li",
          "text": "Bathing and brushing and/or attending grooming appointments"
        },
        {
          "t": "li",
          "text": "Outdoor access & walking: Conducting appropriate amount of walks and exercise if applicable and/or scheduling dog walker/day care"
        },
        {
          "t": "li",
          "text": "Pick up poop/empty litter box daily & weekly maintenance"
        },
        {
          "t": "li",
          "text": "Cleaning up after pet"
        }
      ],
      "msc": "Are your pets healthy, groomed, and socialized?",
      "resources": []
    },
    {
      "id": "school-service-kids",
      "slug": "school-service-kids",
      "sourceId": 76,
      "suit": "caregiving",
      "name": "School Service (Kids)",
      "fullName": "School Service (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 610,
      "definition": "When you agreed to chaperone the museum field trip, it seemed like a worthwhile opportunity to spend time with your child and his classmates. Which it was . . . until you found yourself sitting at the back of a school bus trying not to puke. This card pulls you into a time-sucking vortex that includes reading through a chain of 43 emails (was “reply all” really necessary?), school-sponsored lectures (another one?), and baking cupcakes (nut-free?). And what’s up with schools requesting volunteers to be class “moms”? Dads make excellent class parents, too, ya know.",
      "conception": "The kids have school",
      "planning": [
        {
          "t": "li",
          "text": "Researching volunteer opportunities, which might include the following:"
        },
        {
          "t": "li",
          "text": "Stuffing folders"
        },
        {
          "t": "li",
          "text": "Community service projects"
        },
        {
          "t": "li",
          "text": "Admin work for teachers/school staff"
        },
        {
          "t": "li",
          "text": "Serving as room parent"
        },
        {
          "t": "li",
          "text": "Working with students in small groups"
        },
        {
          "t": "li",
          "text": "Baking for teachers/food for teachers"
        },
        {
          "t": "li",
          "text": "Musical/choir/band/strings concerts"
        },
        {
          "t": "li",
          "text": "Field trip chaperone"
        },
        {
          "t": "li",
          "text": "School picnics and potlucks"
        },
        {
          "t": "li",
          "text": "Lunch, snack, carpool line duty"
        },
        {
          "t": "li",
          "text": "School improvement projects (painting murals, etc.)"
        },
        {
          "t": "li",
          "text": "School fundraisers (bake sales, lemonade stands, etc.)"
        },
        {
          "t": "li",
          "text": "Field day"
        },
        {
          "t": "li",
          "text": "Art fairs"
        },
        {
          "t": "li",
          "text": "Book fairs"
        },
        {
          "t": "li",
          "text": "Talent shows"
        },
        {
          "t": "li",
          "text": "STEM night"
        },
        {
          "t": "li",
          "text": "PTA"
        },
        {
          "t": "li",
          "text": "Class parties"
        },
        {
          "t": "li",
          "text": "Spirit wear"
        },
        {
          "t": "li",
          "text": "Social parents’ nights out"
        },
        {
          "t": "li",
          "text": "Signing up for your commitment/arranging childcare for other children (if applicable)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Showing up for and fulfilling your commitments"
        }
      ],
      "msc": "If this card is important to you both, are you an appropriately active and responsive member of your school community?",
      "resources": []
    },
    {
      "id": "school-transitions-kids",
      "slug": "school-transitions-kids",
      "sourceId": 77,
      "suit": "caregiving",
      "name": "School Transitions (Kids)",
      "fullName": "School Transitions (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 620,
      "definition": "If your child needs to apply to a new school (kindergarten through college), this card may include tours, filling out applications, writing essays, ordering transcripts, test preps for the ACT and SAT, and more. And that work only begins after you’ve completed loads of research about where to apply, considered what might be the best fit for your child, and created your best chances to get in. (Is the lottery really just a lottery? Better find out.)",
      "conception": "The kids have school",
      "planning": [
        {
          "t": "li",
          "text": "Researching potential school options for child"
        },
        {
          "t": "li",
          "text": "Scheduling any necessary academic testing (SAT/ACT)"
        },
        {
          "t": "li",
          "text": "Requesting forms from current school (transcripts etc.)"
        },
        {
          "t": "li",
          "text": "Researching testing prep opportunities"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Touring schools"
        },
        {
          "t": "li",
          "text": "Completing and submitting school applications or open-enrollment forms"
        },
        {
          "t": "li",
          "text": "Attending any mandatory informational meetings or additional get-to-know-you events (e.g. school fundraisers)"
        },
        {
          "t": "li",
          "text": "Signing up for testing prep opportunities"
        }
      ],
      "msc": "Are you in charge of the processes necessary for your child to transition to a new school?",
      "resources": []
    },
    {
      "id": "self-care-player-1",
      "slug": "self-care-player-1",
      "sourceId": 78,
      "suit": "caregiving",
      "name": "Self-Care",
      "fullName": "Self-Care (Player 1)",
      "dailyGrind": false,
      "happinessTrio": true,
      "perPlayer": true,
      "playerSlot": 1,
      "pairKey": "self-care",
      "kids": false,
      "sortOrder": 630,
      "definition": "Each of you gets a self-care card regardless of how many children and other responsibilities you have. For some, a daily multivitamin, a good book, and a hot bath fit the bill. Others may have weekly therapy or wellness appointments, and also set aside regular time to exercise. No guilt or shame allowed. Take this important time for you and allow your partner to do the same.",
      "conception": "You need to take care of yourself",
      "planning": [
        {
          "t": "li",
          "text": "Determining self-care plan, possibly including the following:"
        },
        {
          "t": "li",
          "text": "Nutrition/supplements"
        },
        {
          "t": "li",
          "text": "Exercise routine"
        },
        {
          "t": "li",
          "text": "Doctor and dental appointments (annual physical and mammogram, bloodwork, dental exam/cleaning, ophthalmology, GI, other specialists)"
        },
        {
          "t": "li",
          "text": "Medications"
        },
        {
          "t": "li",
          "text": "Massage/acupuncture"
        },
        {
          "t": "li",
          "text": "Meditation/quiet time/relaxing (TV)/reading"
        },
        {
          "t": "li",
          "text": "Baths"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Showing up for and fulfilling your commitments"
        }
      ],
      "msc": "Do each of you feel reasonably well?",
      "resources": []
    },
    {
      "id": "self-care-player-2",
      "slug": "self-care-player-2",
      "sourceId": 79,
      "suit": "caregiving",
      "name": "Self-Care",
      "fullName": "Self-Care (Player 2)",
      "dailyGrind": false,
      "happinessTrio": true,
      "perPlayer": true,
      "playerSlot": 2,
      "pairKey": "self-care",
      "kids": false,
      "sortOrder": 640,
      "definition": "Each of you gets a self-care card regardless of how many children and other responsibilities you have. For some, a daily multivitamin, a good book, and a hot bath fit the bill. Others may have weekly therapy or wellness appointments, and also set aside regular time to exercise. No guilt or shame allowed. Take this important time for you and allow your partner to do the same.",
      "conception": "You need to take care of yourself",
      "planning": [
        {
          "t": "li",
          "text": "Determining self-care plan, possibly including the following:"
        },
        {
          "t": "li",
          "text": "Nutrition/supplements"
        },
        {
          "t": "li",
          "text": "Exercise routine"
        },
        {
          "t": "li",
          "text": "Doctor and dental appointments (annual physical and mammogram, bloodwork, dental exam/cleaning, ophthalmology, GI, other specialists)"
        },
        {
          "t": "li",
          "text": "Medications"
        },
        {
          "t": "li",
          "text": "Massage/acupuncture"
        },
        {
          "t": "li",
          "text": "Meditation/quiet time/relaxing (TV)/reading"
        },
        {
          "t": "li",
          "text": "Baths"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Showing up for and fulfilling your commitments"
        }
      ],
      "msc": "Do each of you feel reasonably well?",
      "resources": []
    },
    {
      "id": "special-needs-and-mental-health-kids",
      "slug": "special-needs-and-mental-health-kids",
      "sourceId": 81,
      "suit": "caregiving",
      "name": "Special Needs & Mental Health (Kids)",
      "fullName": "Special Needs & Mental Health (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 650,
      "definition": "Obviously, this card needs to be CPE’d with tremendous care if your child has special needs or mental health issues. From identifying the problem to finding the best resources, scheduling appointments, monitoring medication, planning treatment, handling a school IEP, and beyond, this cardholder will steer the ship that guides your child safely and with love. It takes a village, so your Planning should include how to utilize any help from your wider support system to create an environment that fosters progress.",
      "conception": "You need to take care of yourself",
      "planning": [
        {
          "t": "p",
          "text": "$1b"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Working closely w/ “Health Insurance” cardholder to get coverage and medications for the issue"
        },
        {
          "t": "li",
          "text": "Advocating & meeting with school educators to secure necessary supports (i.e., IEP)"
        },
        {
          "t": "li",
          "text": "Supporting child"
        },
        {
          "t": "li",
          "text": "Attending specialist appointments"
        },
        {
          "t": "p",
          "text": "OTHER THINGS TO NOTE IF IT IS AN ALLERGY/FOOD SENSITIVITY:"
        },
        {
          "t": "li",
          "text": "Purchasing EpiPen if needed (or coordinating w/ “Medical & Healthy Living” cardholder)"
        },
        {
          "t": "li",
          "text": "Packing a snack bin for classroom with safe alternative snacks"
        },
        {
          "t": "li",
          "text": "Meeting with the school nurse"
        },
        {
          "t": "li",
          "text": "Asking school to inform other parents to let them know who your child is and what is safe and unsafe for them to eat since they may be volunteering in classroom or sending in treats"
        },
        {
          "t": "li",
          "text": "Purchasing apps that have information for grocery shopping and restaurant finding"
        },
        {
          "t": "li",
          "text": "Always have safe snacks on hand"
        }
      ],
      "msc": "Do each of you feel reasonably well?",
      "resources": []
    },
    {
      "id": "teacher-communication-kids",
      "slug": "teacher-communication-kids",
      "sourceId": 82,
      "suit": "caregiving",
      "name": "Teacher Communication (Kids)",
      "fullName": "Teacher Communication (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 660,
      "definition": "Every teacher and child is different, so this cardholder’s responsibility could be as minimal as showing up to the parent-teacher conference once or twice a year. Or your communication may involve a weekly email exchange or speaking daily and face-to-face to discuss homework and your child’s unique learning needs. As the CPEer, it’s up to you to proactively keep tabs on your kiddos in their school environment to identify potential challenges and work with their teachers to help them thrive.",
      "conception": "You need to communicate with teachers",
      "planning": [
        {
          "t": "li",
          "text": "Receiving and reading teacher emails"
        },
        {
          "t": "li",
          "text": "Scheduling parent-teacher conferences"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Notifying child of important issues"
        },
        {
          "t": "li",
          "text": "Monitoring academic progress, behavior, socialization and school absences"
        },
        {
          "t": "li",
          "text": "Attending parent-teacher conferences"
        },
        {
          "t": "li",
          "text": "Executing teacher recommendations/items to work on with child"
        },
        {
          "t": "li",
          "text": "Communicating plan to Homework and/or Tutoring and Coaching card holder"
        }
      ],
      "msc": "Are you communicating consistently enough to troubleshoot and be proactive in identifying potential challenges?",
      "resources": []
    },
    {
      "id": "adult-friendships-player-1",
      "slug": "adult-friendships-player-1",
      "sourceId": 2,
      "suit": "magic",
      "name": "Adult Friendships",
      "fullName": "Adult Friendships (Player 1)",
      "dailyGrind": false,
      "happinessTrio": true,
      "perPlayer": true,
      "playerSlot": 1,
      "pairKey": "adult-friendships",
      "kids": false,
      "sortOrder": 670,
      "definition": "Each of you gets this card because friends are key to your health, happiness, resilience, career, and sanity. Whether it’s grabbing coffee after school drop-off, a dinner date, a networking event, or a weekend trip away, nurturing friendships will reap huge dividends. Friendships are not a luxury you’ll make time for in the future so use this card guilt-free now. No partner resentment allowed either, as a girls’ or guys’ night out is about so much more than a cocktail. It’s about cultivating relationships that will support and sustain you along with boosting the health of your marriage.",
      "conception": "You need friends",
      "planning": [
        {
          "t": "li",
          "text": "Prioritizing which friends are most important to you"
        },
        {
          "t": "li",
          "text": "Scheduling coffee, lunches, dinners, events, trips with friends"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Connecting with friends weekly (phone, text, email)"
        },
        {
          "t": "li",
          "text": "Taking time to remember friends’ birthdays, successes, challenges"
        },
        {
          "t": "li",
          "text": "Supporting friends during both happy and sad times"
        }
      ],
      "msc": "Do you have friends and do you see them?",
      "resources": []
    },
    {
      "id": "adult-friendships-player-2",
      "slug": "adult-friendships-player-2",
      "sourceId": 1,
      "suit": "magic",
      "name": "Adult Friendships",
      "fullName": "Adult Friendships (Player 2)",
      "dailyGrind": false,
      "happinessTrio": true,
      "perPlayer": true,
      "playerSlot": 2,
      "pairKey": "adult-friendships",
      "kids": false,
      "sortOrder": 680,
      "definition": "Each of you gets this card because friends are key to your health, happiness, resilience, career, and sanity. Whether it’s grabbing coffee after school drop-off, a dinner date, a networking event, or a weekend trip away, nurturing friendships will reap huge dividends. Friendships are not a luxury you’ll make time for in the future, so use this card guilt-free now. No partner resentment allowed either, as a girls’ or guys’ night out is about so much more than a cocktail. It’s about cultivating relationships that will support and sustain you, along with boosting the health of your marriage.",
      "conception": "You need friends",
      "planning": [
        {
          "t": "li",
          "text": "Prioritizing which friends are most important to you"
        },
        {
          "t": "li",
          "text": "Scheduling coffee, lunches, dinners, events, trips with friends"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Connecting with friends weekly (phone, text, email)"
        },
        {
          "t": "li",
          "text": "Taking time to remember friends’ birthdays, successes, challenges"
        },
        {
          "t": "li",
          "text": "Supporting friends during both happy and sad times"
        }
      ],
      "msc": "Do you have friends and do you see them?",
      "resources": []
    },
    {
      "id": "birthday-celebration-your-kids",
      "slug": "birthday-celebration-your-kids",
      "sourceId": 84,
      "suit": "magic",
      "name": "Birthday Celebration (Your Kids)",
      "fullName": "Birthday Celebration (Your Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 690,
      "definition": "Have you ever tried shoving a dozen balloons into the trunk of your car? It’s like playing a game of whack-a-mole, but you get no prize. How about copying and pasting email addresses for the whole class into your online invitation? Time suck. These are just illustrations of the many tasks you’ll handle when planning your child’s birthday party. Even if you keep it simple with a family dinner at home, this cardholder might be the one who battles rush-hour traffic to pick up a cake at a favorite bakery before it closes. Don’t forget candles, but no need to buy a present unless you’re also the “Gifts (Family)” lead.",
      "conception": "Your kids have birthdays",
      "planning": [
        {
          "t": "li",
          "text": "Discussing party expectations with your child"
        },
        {
          "t": "li",
          "text": "Creating an invite list"
        },
        {
          "t": "li",
          "text": "Researching party location options, including available dates, pricing, and number of children allowed"
        },
        {
          "t": "li",
          "text": "Planning family dinner and other special surprises for day of"
        },
        {
          "t": "li",
          "text": "In school birthday party preparation and supplies"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Booking entertainment"
        },
        {
          "t": "li",
          "text": "Designing an online invitation or ordering printed ones and sending"
        },
        {
          "t": "li",
          "text": "Ordering favors, decorations, cake, candles, and paper products for party"
        },
        {
          "t": "p",
          "text": "Note: Purchasing gifts is the responsibility of the “Gifts (Family)” cardholder"
        }
      ],
      "msc": "Did the celebration honor your child in a way that felt good to them?",
      "resources": []
    },
    {
      "id": "discipline-and-screen-time-kids",
      "slug": "discipline-and-screen-time-kids",
      "sourceId": 85,
      "suit": "magic",
      "name": "Discipline & Screen Time (Kids)",
      "fullName": "Discipline & Screen Time (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 700,
      "definition": "While it’s no fun to discipline kids, the Magic is in setting critical boundaries and giving them tools that will impact how safe they feel and how they conduct themselves for a lifetime. The goal is not for one parent to be responsible for discipline while the other holds “Fun! & Playing” forever. That’s why this card requires ongoing collaboration between partners, with one cardholder at a time taking the lead. For example, screen time. This came up as the most discussed disciplinary issue within families. It’s a biggie, and if you hold this card, you may conduct research about an appropriate amount of screen time for your kids and consult with your partner about reasonable boundaries, along with the parameters for taking it away; then you’ll each enforce your family’s rules and consequences on an ongoing basis.",
      "conception": "Your kids make mistakes",
      "planning": [
        {
          "t": "li",
          "text": "Researching appropriate discipline for different life stages"
        },
        {
          "t": "li",
          "text": "Devising a strategy to recommend to your spouse"
        },
        {
          "t": "li",
          "text": "Setting up parental controls, negotiating what games/sites your kid can visit, downloading one of those apps that turns the Wi-Fi off on your child’s device after a certain number of minutes"
        },
        {
          "t": "li",
          "text": "Informing childcare helpers of limits as needed"
        },
        {
          "t": "li",
          "text": "Updating plan as needed"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Informing child and enforcing limits"
        }
      ],
      "msc": "Are you guiding your children to know right from wrong and the consequences of their actions? What is appropriate for them to watch and for how long?",
      "resources": []
    },
    {
      "id": "extended-family",
      "slug": "extended-family",
      "sourceId": 86,
      "suit": "magic",
      "name": "Extended Family",
      "fullName": "Extended Family",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 710,
      "definition": "Someone’s got to remember to call Great-Aunt Mary on her ninetieth birthday. Same goes for scheduling playdates with cousins if you want the kids to have a relationship (even if you’re the one who always ends up doing the two-hour round-trip drive). Depending on how much you and your partner value this card, this CPEer might plan frequent get-togethers with relatives or just be the one to remember to invite Uncle Norman to Thanksgiving dinner, knowing full well he’ll have one too many drinks and talk politics all night.",
      "conception": "Your kids make mistakes",
      "planning": [
        {
          "t": "li",
          "text": "Staying apprised of health, financial concerns and lives of extended family"
        },
        {
          "t": "li",
          "text": "Deciding whom to see and planning dates/scheduling family dinners, visits, and reunions"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Key milestone/time of year/illness calls and correspondence: birthday, holidays, graduations, illness/hospital visits, etc."
        },
        {
          "t": "li",
          "text": "Implementing extended family plans"
        }
      ],
      "msc": "Is there a quality relationship with your extended family?",
      "resources": []
    },
    {
      "id": "fun-and-playing-kids",
      "slug": "fun-and-playing-kids",
      "sourceId": 87,
      "suit": "magic",
      "name": "Fun & Playing (Kids)",
      "fullName": "Fun & Playing (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 720,
      "definition": "Maybe you’ve forgotten that parenting is fun! So fun that after you take your kids to the indoor water park they begged you to take them to, your ensuing urinary tract infection feels totally worth it. Seriously, childhood should include interactive playful moments as a family on a regular basis, and those moments and memories are, in fact, magical (UTI notwithstanding). This cardholder will CPE ongoing time for fun, such as arranging to throw a football around in the park at twilight, creating a weekly family game night, or any other activities your kids enjoy. Holding this card can be a blast, so be sure to hand it back and forth regularly with your partner and spread the fun around.",
      "conception": "You want your kids to have fun",
      "planning": [
        {
          "t": "li",
          "text": "Planning consistent opportunities for family fun: game nights, reading together, playing sports, hiking, races, biking, running, building forts/blocks/Legos, playgrounds, amusement parks, magic, kites, science, tinkering, fun runs, dances, baking, special projects, etc."
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Executing consistent opportunities for family fun"
        }
      ],
      "msc": "Has your family shared some interactive playful moments recently?",
      "resources": []
    },
    {
      "id": "gestures-of-love-kids",
      "slug": "gestures-of-love-kids",
      "sourceId": 88,
      "suit": "magic",
      "name": "Gestures of Love (Kids)",
      "fullName": "Gestures of Love (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 730,
      "definition": "You know that mom who leaves handwritten notes in her kid’s lunch box that read “I love you to the moon and back”? Or the dad who drops by basketball practice for a quick hug? With some thought, time, and effort—some CPE, if you will—that parent could be you, making every day a little more special for everyone.\n\nNote! You’re both equally capable of having the forethought and spending the time to buy a bouquet of flowers before your child’s dance recital, but trust me on this—even gestures of love benefit from one person taking the lead. To ensure that the gesture isn’t missed or forgotten, assign one person to pick up flowers for the recital this week, and then redeal to assign a lead next week.",
      "conception": "You want your kids to feel love and seen",
      "planning": [
        {
          "t": "li",
          "text": "Creating plan for appropriate gestures"
        },
        {
          "t": "li",
          "text": "May include: flowers for recitals, notes on mirrors/lunch boxes, family hugs, surprise pick-up, etc."
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Following through on planned gestures"
        }
      ],
      "msc": "Would your kid report random acts of kindness from you if asked? (i.e., flowers at their recital)",
      "resources": []
    },
    {
      "id": "gifts-family",
      "slug": "gifts-family",
      "sourceId": 89,
      "suit": "magic",
      "name": "Gifts (Family)",
      "fullName": "Gifts (Family)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 740,
      "definition": "Gift giving is not about buying something because a date on the calendar compels you to. When you get it right, it’s about connection and appreciation. The Magic here lies in finding gifts and writing cards that will make your family members feel special when a holiday, graduation, birthday, or any other occasion comes around. So the next time you see a card with a message that would resonate with your child, you might purchase it even though his or her birthday is a few months away.\n\nTip! Re-deal as needed so you don’t have to buy birthday gifts for yourself.",
      "conception": "You give gifts to family members",
      "planning": [
        {
          "t": "li",
          "text": "Noting occasions (birthdays, holidays, Mother’s/Father’s Day) and people (children, parents, aunts/uncles, grandparents, etc.) that may require gifts"
        },
        {
          "t": "p",
          "text": "Exception: Cards/correspondence for extended family, parents, and in-laws stay with those “Extended Family” and “Parents & In-Laws” cardholders."
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing birthday cards and presents (having children/partner sign)"
        },
        {
          "t": "li",
          "text": "Wrapping presents"
        },
        {
          "t": "li",
          "text": "Shipping gifts if necessary"
        }
      ],
      "msc": "Are thoughtful gifts given at the appropriate times?",
      "resources": []
    },
    {
      "id": "gifts-vip",
      "slug": "gifts-vip",
      "sourceId": 90,
      "suit": "magic",
      "name": "Gifts (VIP)",
      "fullName": "Gifts (VIP)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 750,
      "definition": "When it comes to Very Important People gift giving, the recipient might be your child’s teacher, coach, or the neighbors hosting you two doors down. If regifting is your thing, then CPEing this card can be easy and straightforward. Alternatively, this cardholder may wish to spend more time personalizing gifts and writing heartfelt cards. Either way—or somewhere in the middle—gift giving is an opportunity to connect with and thank the very important people in your life, which requires year-round CPE. Exception: Other kids’ birthday gifts stay with the “Birthday Celebrations (Other Kids)” cardholder.",
      "conception": "You give gifts to family members",
      "planning": [
        {
          "t": "li",
          "text": "Noting occasions (invite to someone’s home, end of season coaching party, holiday time) and people (friends, coaches, teachers, childcare helpers, service providers such as mail carrier) that may require gifts"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing birthday cards and presents (having children/partner sign)"
        },
        {
          "t": "li",
          "text": "Wrapping presents"
        },
        {
          "t": "li",
          "text": "Shipping gifts if necessary"
        }
      ],
      "msc": "Are thoughtful gifts given at the appropriate times?",
      "resources": []
    },
    {
      "id": "hard-question-kids",
      "slug": "hard-question-kids",
      "sourceId": 83,
      "suit": "magic",
      "name": "Hard Question (Kids)",
      "fullName": "Hard Question (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 760,
      "definition": "“Why do I have hair growing under my armpits?” “What does it mean when the other kids talk about ‘doing it’?” Enough said. You and your partner may re-deal this card to each other based on the question at hand or which child is asking, but when it’s your turn, be prepared as best you can to research and impart thoughtful, accurate, and age-appropriate wisdom. Spoiler alert: The questions get tougher, and the stakes get higher as your kids grow up.",
      "conception": "Your kids have questions",
      "planning": [
        {
          "t": "li",
          "text": "Determining the appropriate age to discuss certain topics with your child (puberty, gender, sex/pornography, sexuality, drugs/alcohol, suicide, religion, family choices)"
        },
        {
          "t": "li",
          "text": "Connecting with friends who have older children to gather advice on how to introduce difficult topics"
        },
        {
          "t": "li",
          "text": "Consulting with doctors, professionals, and/or community resources when necessary"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing age-appropriate books to help educate your children"
        },
        {
          "t": "li",
          "text": "Being available for and open when answering your children’s questions"
        }
      ],
      "msc": "Are your children’s hard questions appropriately researched and answered in a way that feels good to both of you?",
      "resources": []
    },
    {
      "id": "holiday-cards",
      "slug": "holiday-cards",
      "sourceId": 91,
      "suit": "magic",
      "name": "Holiday Cards",
      "fullName": "Holiday Cards",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 770,
      "definition": "Get ready to turn the already chaotic holidays into a job filled with a spreadsheet of personal contacts (did they move?), address labels, and the inevitable returned cards that haunt you until next year. The amount of time—even if you go digital with an e-card—is colossal. Not to mention the nearly impossible feat of taking a family picture with everyone looking in the same direction and smiling! But think about it: It’s the one time a year Cousin Susie sees a picture of your growing family. In other words, holiday cards can be a meaningful touch point that makes all the CPE well worth it.",
      "conception": "You want to send holiday cards",
      "planning": [
        {
          "t": "li",
          "text": "Obtaining appropriate photo from “Memories & Photos” cardholder"
        },
        {
          "t": "li",
          "text": "Creating address list and updating addresses if needed"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing birthday cards and presents (having children/partner sign)"
        },
        {
          "t": "li",
          "text": "Wrapping presents"
        },
        {
          "t": "li",
          "text": "Printing labels or addressing envelopes"
        },
        {
          "t": "li",
          "text": "Purchasing stamps (or ask “Mail” cardholder to provide)"
        },
        {
          "t": "li",
          "text": "Applying labels/stamps"
        },
        {
          "t": "li",
          "text": "Mailing cards"
        }
      ],
      "msc": "Did the cards arrive in the desired mailboxes at the appropriate time?",
      "resources": []
    },
    {
      "id": "holidays",
      "slug": "holidays",
      "sourceId": 92,
      "suit": "magic",
      "name": "Holidays",
      "fullName": "Holidays",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 780,
      "definition": "Just the time it takes to get holiday ornaments out of storage and unwrap them merits a glass of wine (or three), and that’s before the hard work even begins. From cooking to decor to all the logistics, CPEing any holiday is like running an event-planning company—sans the paycheck. When the kids want to attempt their own impossible-to-make (but too-cute-to-resist) Halloween costumes, this cardholder will make the Magic happen. Same goes for figuring out who’s hosting Thanksgiving, organizing Easter brunch with second cousins twice removed, and every other holiday and special ritual that your family celebrates. Saving grace: “Travel,” “Gifts (Family)” and “Magical Beings” cards are not included in this card. In other words, leaving cookies out for Santa isn’t on you.",
      "conception": "You celebrate holidays",
      "planning": [
        {
          "t": "li",
          "text": "Conceiving a holiday plan (discussing with “Travel & Hosting” cardholders) for:"
        },
        {
          "t": "li",
          "text": "Family specialty dishes"
        },
        {
          "t": "li",
          "text": "Decorations/décor"
        },
        {
          "t": "li",
          "text": "Day of holiday festivities/rituals/family gatherings"
        },
        {
          "t": "p",
          "text": "Exception: “Gifts (Family),” “Gifts (VIPs),” and “Magical Beings” (e.g., Santa) are separate cards."
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Executing a holiday plan"
        }
      ],
      "msc": "Is the holiday reflective of your traditions that will create lasting memories and family nostalgia?",
      "resources": []
    },
    {
      "id": "informal-education-kids",
      "slug": "informal-education-kids",
      "sourceId": 93,
      "suit": "magic",
      "name": "Informal Education (Kids)",
      "fullName": "Informal Education (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 790,
      "definition": "Do you remember who taught you how to hold your breath underwater? Throw a ball? Ride a bike? Of course you do, and so will your child as soon as this cardholder gets to work. Kudos to you for the countless hours you’ll spend hovering over a bike seat with your back wrenched—that’s the Execution—but pay special attention to the Conception and Planning, as well. Start thinking now about those special milestone moments and life skills you want to teach your children. (Hint: If your kid is the only one in class still wearing Velcro sneakers, you might want to remedy that by teaching him to tie his shoes.)",
      "conception": "You want your kids to learn",
      "planning": [
        {
          "t": "li",
          "text": "Determining age-appropriate skills for children (e.g., shoe tying, buttoning a shirt, bike riding, etiquette/manners/how to write a thank you note, preparing a meal)"
        },
        {
          "t": "li",
          "text": "Setting a chores list as they grow (coordinate with the related cardholders)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Implement plan to impart skills"
        },
        {
          "t": "li",
          "text": "Modeling chores/manners"
        },
        {
          "t": "li",
          "text": "Enforcing a chores list as they grow"
        }
      ],
      "msc": "Is your child developing age-appropriate life skills without too much stress?",
      "resources": []
    },
    {
      "id": "magical-beings-kids",
      "slug": "magical-beings-kids",
      "sourceId": 94,
      "suit": "magic",
      "name": "Magical Beings (Kids)",
      "fullName": "Magical Beings (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 800,
      "definition": "By holding this card, you hold the CPE required to keep your child’s dreams and imagination alive. When it comes to the Tooth Fairy, Elf on the Shelf, Santa Claus, the Easter Bunny, the Mensch on a Bench, Saint Patrick’s Day leprechauns, the Switch Witch, or any other magical being that you introduce into your family, believing in the unbelievable disappears quickly. Put in the time and effort today to make the Magic come to life.",
      "conception": "You celebrate holidays",
      "planning": [
        {
          "t": "li",
          "text": "Determining which being to introduce (e.g., Tooth Fairy, Santa Claus, Easter Bunny, Elf on the Shelf, Mensch on a Bench, Saint Patrick’s Day leprechauns, Switch Witch)"
        },
        {
          "t": "li",
          "text": "Preparing a plan for each being introduced"
        },
        {
          "t": "li",
          "text": "Setting alarm"
        },
        {
          "t": "li",
          "text": "Having magical being talks (real v. not real)"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Purchasing the magical being supplies"
        },
        {
          "t": "li",
          "text": "Executing plan"
        }
      ],
      "msc": "Does your kid believe in the chosen magical being until a reasonable age?",
      "resources": []
    },
    {
      "id": "marriage-and-romance",
      "slug": "marriage-and-romance",
      "sourceId": 95,
      "suit": "magic",
      "name": "Marriage & Romance",
      "fullName": "Marriage & Romance",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 810,
      "definition": "#herofail is what one mom called it when her husband scheduled a series of surprise romantic dinners on Thursday nights, not realizing that’s when she holds the “transportation (kids)” card for their daughter’s play rehearsals. Her husband’s heart was in the right place, but this card (like all of ’em) takes Conception, Planning, and Execution—emphasis needed on the Planning in his case. This cardholder might be the one who, for example, initiates a regular date night (on a night that works!). Planning for kid-free time can feel like a logistical nightmare (scheduling a sitter, coordinating calendars, and agreeing on details), but cardholders who pull it off report it’s well worth it.",
      "conception": "You have a partnership",
      "planning": [
        {
          "t": "li",
          "text": "Conceiving of thoughtful gestures for your spouse (gifts, cooking a meal, a note, flowers)"
        },
        {
          "t": "li",
          "text": "Ensuring that time is set aside for just the two of you on a regular basis"
        },
        {
          "t": "li",
          "text": "Scheduling date nights, including making dinner reservations, show tickets etc."
        },
        {
          "t": "li",
          "text": "Scheduling couple-only trips with “Travel” cardholder"
        },
        {
          "t": "li",
          "text": "Planning time for intimacy"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Executing consistent opportunities for family fun"
        }
      ],
      "msc": "Is there a reasonable effort made to maintain you and your partner’s connection?",
      "resources": []
    },
    {
      "id": "middle-of-the-night-comfort-kids",
      "slug": "middle-of-the-night-comfort-kids",
      "sourceId": 96,
      "suit": "magic",
      "name": "Middle Of The Night Comfort (Kids)",
      "fullName": "Middle Of The Night Comfort (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 820,
      "definition": "Define “middle of the night” as you see fit, because when daylight savings time hits, you may think of this as the “way too early to be morning” card that leaves you dog-tired and at your wits’ end. (It’s amazing how just one hour can do so much damage!) Bad dreams at 3 a.m., cries of “I can’t sleep!” just when you’re curled up in bed to watch TV, and help with trips to the toilet for that stomach bug going around are all in this cardholder’s hands. As one woman explained it, “When my husband has middle-of-the-night duty, I refer to this as the ‘Don’t call Mom’ card!”",
      "conception": "The kids wake up in the middle of the night",
      "planning": [
        {
          "t": "li",
          "text": "Making yourself available for your children following bedtime routine, including:"
        },
        {
          "t": "li",
          "text": "Trouble falling asleep"
        },
        {
          "t": "li",
          "text": "Middle of the night feedings"
        },
        {
          "t": "li",
          "text": "Night terrors"
        },
        {
          "t": "li",
          "text": "Bed-wetting"
        },
        {
          "t": "li",
          "text": "Researching, creating a plan, gathering input from partner about sleep training"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Executing plan for sleep training"
        }
      ],
      "msc": "Do your kids have consistent access to a designated parent if middle-of-the-night issues arise?",
      "resources": []
    },
    {
      "id": "partner-coach",
      "slug": "partner-coach",
      "sourceId": 97,
      "suit": "magic",
      "name": "Partner Coach",
      "fullName": "Partner Coach",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 830,
      "definition": "Every time you help your loved one with their work, you are engaging in the highly invisible work of partner coaching. When you edit an email before your husband sends it to his boss, help him plan an important outing with a client, or lie in bed at night thinking through how he could be considered for a promotion, you are doing the loving and often unrecognized work of “coaching” your partner. This card can be one-sided (that is, a wife helping a husband but not the other way around). The aspiration is to hand off the card more equitably so both partners can benefit from each other’s support and advice.",
      "conception": "You are in a partnership",
      "planning": [
        {
          "t": "li",
          "text": "Consulting with spouse about what is needed to enrich career. Examples include the following:"
        },
        {
          "t": "li",
          "text": "Writing/editing/reviewing resumes, emails, contracts, and other business-related correspondence"
        },
        {
          "t": "li",
          "text": "Fostering relationships with spouse’s boss/co-workers"
        },
        {
          "t": "li",
          "text": "Writing/editing/reviewing resumes, manuscripts, presentations, talking points, spreadsheets, speeches, and other work product."
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Following through on what your partner needs and spending the appropriate amount of time doing so with your full attention."
        }
      ],
      "msc": "Was your contribution timely, relevant, and a priority?",
      "resources": []
    },
    {
      "id": "showing-up-and-participating-kids",
      "slug": "showing-up-and-participating-kids",
      "sourceId": 98,
      "suit": "magic",
      "name": "Showing Up & Participating (Kids)",
      "fullName": "Showing Up & Participating (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 840,
      "definition": "One dad admits that he spent nearly a month complaining about the daddy/daughter dance at school, dreading everything from the small talk with other dads to the awkwardness of busting out his moves. Ultimately, he went, and it turned out to be pure Magic for both him and his growing-up-too-fast fourth grader. You’ve got to show up for and participate in your child’s events, big and small, for the Magic to happen. Re-deal this card frequently to make sure it does.",
      "conception": "You need to show up for the kids",
      "planning": [
        {
          "t": "p",
          "text": "*Note: No CPE other than showing up on time. Play this card to feel included but not to have to do any of the work of the other cardholders."
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Attending (on time) children’s games, shows, recitals, and other special presentations, curriculum/development/education nights"
        }
      ],
      "msc": "Are you on time when you say you are going to be?",
      "resources": []
    },
    {
      "id": "spirituality",
      "slug": "spirituality",
      "sourceId": 99,
      "suit": "magic",
      "name": "Spirituality",
      "fullName": "Spirituality",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 850,
      "definition": "This card looks and feels different to everyone—perhaps even within your own home—so all the more reason you should consult your partner in the Planning to make sure you’re on the same page. (Ahem, you don’t have carte blanche to join a cult just because it’s your card.) It may involve attending church/synagogue/mosque, planning events like communion or a bar/bat mitzvah, establishing a relationship with clergy members, enforcing dietary beliefs, creating a family meditation ritual, or any number of ways you decide to make spirituality a part of your family’s life.",
      "conception": "You want to practice spirituality",
      "planning": [
        {
          "t": "li",
          "text": "Researching local churches/temples/synagogues/spiritual centers in your area"
        },
        {
          "t": "li",
          "text": "Registering for Sunday school / Hebrew school / confirmation class"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Attending religious services on holidays or weekly"
        },
        {
          "t": "li",
          "text": "Educating children / rituals in the home"
        },
        {
          "t": "li",
          "text": "Buying high holiday tickets (if applicable)"
        }
      ],
      "msc": "Is your life one where there is a practice of a higher purpose? Does it include your children?",
      "resources": []
    },
    {
      "id": "thank-you-notes",
      "slug": "thank-you-notes",
      "sourceId": 101,
      "suit": "magic",
      "name": "Thank You Notes",
      "fullName": "Thank You Notes",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 860,
      "definition": "Why would the dreaded task of writing thank-you notes be considered Magic? Because thank-you notes are an opportunity to express gratitude to people who inspire you to feel it. If you have family dinner with friends, you might send an email letting them know how wonderful it was to spend time together. When a colleague delivers a huge bag of hand-me-downs for your kids, that thoughtfulness merits a note. Imagine a life where sleep-deprived postpartum moms are not saddled with writing thank-you notes for baby gifts. That can be your reality, as either partner is capable of CPEing this card.",
      "conception": "You want to express gratitude",
      "planning": [
        {
          "t": "li",
          "text": "Obtaining appropriate information"
        },
        {
          "t": "li",
          "text": "Creating address list and updating addresses if needed"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Printing labels or addressing envelopes"
        },
        {
          "t": "li",
          "text": "Purchasing stamps (or ask “Mail” cardholder to provide)"
        },
        {
          "t": "li",
          "text": "Applying labels/stamps"
        },
        {
          "t": "li",
          "text": "Mailing cards"
        }
      ],
      "msc": "Did the cards arrive in the desired mailboxes at the appropriate time?",
      "resources": []
    },
    {
      "id": "values-and-good-deeds-kids",
      "slug": "values-and-good-deeds-kids",
      "sourceId": 100,
      "suit": "magic",
      "name": "Values & Good Deeds (Kids)",
      "fullName": "Values & Good Deeds (Kids)",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 870,
      "definition": "You know those families who you look up to because the kids have rock-solid values? This kind of Magic takes time and consistency. In other words, one visit to the soup kitchen does not a good kid make. If you want to be the family who feeds the homeless every Thanksgiving, start researching places to volunteer. If you want to make birthdays feel special without any semblance of materialism, start a tradition like a family hug on the time your child was born. (Unless it’s in the middle of the night—then wait until the morning.) Soon you’ll be the family who everyone else is talking about for the right reasons.",
      "conception": "You want your kids to have values",
      "planning": [
        {
          "t": "li",
          "text": "Considering values to impart"
        },
        {
          "t": "li",
          "text": "Researching allowance and consulting with “Cash & Bills” cardholder (spend, save, charity jars)"
        },
        {
          "t": "li",
          "text": "Researching and scheduling family giving-back/community service opportunities"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Attending family giving-back/community service opportunities"
        },
        {
          "t": "li",
          "text": "Modeling values"
        }
      ],
      "msc": "Do your kids feel good about what they contribute to the community?",
      "resources": []
    },
    {
      "id": "watching-kids",
      "slug": "watching-kids",
      "sourceId": 80,
      "suit": "magic",
      "name": "Watching (Kids)",
      "fullName": "Watching (Kids)",
      "dailyGrind": true,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": true,
      "sortOrder": 880,
      "definition": "If you have a little one, then you know that having eyes on your child is endless at the baby/toddler stage. Older children need watching, too, like preventing your ten-year-old from spraying WD-40 all over the living room when he mistakes it for air freshener (true story), or walking by your teen’s bedroom door constantly to make sure it’s open while a “friend” is over. Good news: It’s amazing what can happen when you put down your phone and really watch your kids. Watching a one-year-old may feel uneventful, but this is when you witness your child’s first steps! Depending on what time of day you hold this card and the age of your child, you may also be responsible for taking the lead on a number of other cards, such as “diapering and potty training,” “bedtime routine,” “meals” “transportation (kids),” and “tidying up.” (If you build a fort in your living room while you’re on “watch,” then it’s only fair that you break it down and tidy up before re-dealing this card to your spouse or other caregivers.)",
      "conception": "The kids have school",
      "planning": [
        {
          "t": "p",
          "text": "$1c"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Executing the plan for watching with full attention"
        }
      ],
      "msc": "When under your watch, is the child safe, appropriately fed, and are you reasonably present and spending time on activities consistent and intentionally aligned with your family standards?",
      "resources": []
    },
    {
      "id": "aging-ailing-parent",
      "slug": "aging-ailing-parent",
      "sourceId": 3,
      "suit": "wild",
      "name": "Aging/Ailing Parent",
      "fullName": "Aging/Ailing Parent",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 890,
      "definition": "Sandwich generation, anyone? From managing medications, meals, and doctors’ appointments to making visiting a priority, caring for an aging/ailing parent can be all-consuming, not to mention the emotional challenge of this inevitable but often unexpected new caregiver role. Even if you outsource some of the work or can afford in-home or assisted-living support, CPEing this card requires all the love in your heart and a good chunk of your time.",
      "conception": "The Wild suit includes life-changing scenarios that rock your world, and come with a mind-numbing amount of invisible work. When you’re dealt a Wild card (hopefully temporarily), you’re entitled to ask for additional help from your partner guilt-free. Your partner is encouraged to reach out to your village for even more support, but the Wild cardholder is not the one who handles this delegation. You and your partner are also encouraged to remove cards from your deck, temporarily, while dealing with a Wild card.",
      "planning": [],
      "execution": [],
      "msc": "Do you feel supported to take the lead on this wildcard? Will your partner be stepping up to take on other cards?",
      "resources": []
    },
    {
      "id": "death",
      "slug": "death",
      "sourceId": 51,
      "suit": "wild",
      "name": "Death",
      "fullName": "Death",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 900,
      "definition": "As if the loss of a loved one isn’t unbearable enough, there are also many important items of business requiring your time, including arranging a funeral, a shiva or other spiritual or religious rituals, and then acknowledging those who paid their respects. If handling any will or estate issues and packing up your loved one’s home and belongings are your responsibilities, prepare to be holding this card for quite some time.",
      "conception": "The Wild suit includes life-changing scenarios that rock your world, and come with a mind-numbing amount of invisible work. When you’re dealt a Wild card (hopefully temporarily), you’re entitled to ask for additional help from your partner guilt-free. Your partner is encouraged to reach out to your village for even more support, but the Wild cardholder is not the one who handles this delegation. You and your partner are also encouraged to remove cards from your deck, temporarily, while dealing with a Wild card.",
      "planning": [],
      "execution": [],
      "msc": "Do you feel supported to take the lead on this wildcard? Will your partner be stepping up to take on other cards?",
      "resources": [
        {
          "title": "The Fair Play Guide to Grief & Loss",
          "url": "https://fairplay.myflodesk.com/grief"
        }
      ]
    },
    {
      "id": "first-year-of-infants-life",
      "slug": "first-year-of-infants-life",
      "sourceId": 52,
      "suit": "wild",
      "name": "First Year of Infant's Life",
      "fullName": "First Year of Infant's Life",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 910,
      "definition": "Unsettled hormones, sleep deprivation, and a ravaged body are enough to make this a Wild card, not to mention that your time has all but disappeared. The days of having even a consecutive two-hour stretch of time to be productive are a vague memory as you drown in nursing/feeding, diaper changing, comforting your baby around the clock, and an innumerable amount of other to-dos all courtesy of your bundle of joy. Make no mistake: The first year of an infant’s life is not only a “Mom thing.” There’s plenty for Dad to do, too. While you’re trying to survive another day, let him dig into the Daily Grind cards: “laundry,” “dishes,” “garbage,” “groceries,” and taking the lead on “meals (weekday dinner).”",
      "conception": "The Wild suit includes life-changing scenarios that rock your world, and come with a mind-numbing amount of invisible work. When you’re dealt a Wild card (hopefully temporarily), you’re entitled to ask for additional help from your partner guilt-free. Your partner is encouraged to reach out to your village for even more support, but the Wild cardholder is not the one who handles this delegation. You and your partner are also encouraged to remove cards from your deck, temporarily, while dealing with a Wild card.",
      "planning": [],
      "execution": [],
      "msc": "Do you feel supported to take the lead on this wildcard? Will your partner be stepping up to take on other cards?",
      "resources": []
    },
    {
      "id": "glitch-in-the-matrix-daily-disruption",
      "slug": "glitch-in-the-matrix-daily-disruption",
      "sourceId": 53,
      "suit": "wild",
      "name": "Glitch In The Matrix / Daily Disruption",
      "fullName": "Glitch In The Matrix / Daily Disruption",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 920,
      "definition": "The last thing in the world you have time for is dealing with the unexpected disruption of a fender bender, a computer virus, a flooded basement . . . or having the phone ring and seeing the dreaded school phone number. Your child has lice . . . can you come pick her up? You don’t get a vote when a Wild card lands in your lap, but you do get to ask for a helping hand from your partner when a daily disruption torpedoes your day. Remember: Leaving work early because of X, Y, or Z is not “on you” unless you currently hold this card.",
      "conception": "The Wild suit includes life-changing scenarios that rock your world, and come with a mind-numbing amount of invisible work. When you’re dealt a Wild card (hopefully temporarily), you’re entitled to ask for additional help from your partner guilt-free. Your partner is encouraged to reach out to your village for even more support, but the Wild cardholder is not the one who handles this delegation. You and your partner are also encouraged to remove cards from your deck, temporarily, while dealing with a Wild card.",
      "planning": [],
      "execution": [],
      "msc": "Do you feel supported to take the lead on this wildcard? Will your partner be stepping up to take on other cards?",
      "resources": []
    },
    {
      "id": "home-renovation",
      "slug": "home-renovation",
      "sourceId": 54,
      "suit": "wild",
      "name": "Home Renovation",
      "fullName": "Home Renovation",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 930,
      "definition": "Wild cards fall on a spectrum in terms of how life-altering and time-consuming the predicament can be. Obviously installing new toilets or kitchen cabinets is not as serious an endeavor as keeping your newborn nourished or managing a parent’s chemotherapy schedule. Still, it sure would be nice to have a working toilet and a functional kitchen, so someone’s got to do the work to make that happen.",
      "conception": "The Wild suit includes life-changing scenarios that rock your world, and come with a mind-numbing amount of invisible work. When you’re dealt a Wild card (hopefully temporarily), you’re entitled to ask for additional help from your partner guilt-free. Your partner is encouraged to reach out to your village for even more support, but the Wild cardholder is not the one who handles this delegation. You and your partner are also encouraged to remove cards from your deck, temporarily, while dealing with a Wild card.",
      "planning": [],
      "execution": [],
      "msc": "Do you feel supported to take the lead on this wildcard? Will your partner be stepping up to take on other cards?",
      "resources": []
    },
    {
      "id": "job-loss-and-money-problems",
      "slug": "job-loss-and-money-problems",
      "sourceId": 56,
      "suit": "wild",
      "name": "Job Loss & Money Problems",
      "fullName": "Job Loss & Money Problems",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 940,
      "definition": "Serious financial issues like unemployment or bankruptcy require heavy lifting that may include networking, job interviews, court appearances, and many other time-sucking items of business. Of course, you’re both impacted by the stressful issue at hand, but this cardholder takes the lead on resolving it while consulting with the “Money Manager” so your family’s budget can be modified accordingly.",
      "conception": "The Wild suit includes life-changing scenarios that rock your world, and come with a mind-numbing amount of invisible work. When you’re dealt a Wild card (hopefully temporarily), you’re entitled to ask for additional help from your partner guilt-free. Your partner is encouraged to reach out to your village for even more support, but the Wild cardholder is not the one who handles this delegation. You and your partner are also encouraged to remove cards from your deck, temporarily, while dealing with a Wild card.",
      "planning": [],
      "execution": [],
      "msc": "Do you feel supported to take the lead on this wildcard? Will your partner be stepping up to take on other cards?",
      "resources": []
    },
    {
      "id": "moving",
      "slug": "moving",
      "sourceId": 57,
      "suit": "wild",
      "name": "Moving",
      "fullName": "Moving",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 950,
      "definition": "There’s a reason why moving is typically on the Top 10 list of hellish events; it can be as stressful as the death of a loved one, divorce, or unemployment. The process of purging, packing, relocating, organizing, storing, and living in disarray is all-consuming, disruptive to your family’s routines, and basically upends your life. Good news: It’s temporary. Bad news: It’s a CPE doozy. Who is better equipped to take the lead?",
      "conception": "The Wild suit includes life-changing scenarios that rock your world, and come with a mind-numbing amount of invisible work. When you’re dealt a Wild card (hopefully temporarily), you’re entitled to ask for additional help from your partner guilt-free. Your partner is encouraged to reach out to your village for even more support, but the Wild cardholder is not the one who handles this delegation. You and your partner are also encouraged to remove cards from your deck, temporarily, while dealing with a Wild card.",
      "planning": [],
      "execution": [],
      "msc": "Do you feel supported to take the lead on this wildcard? Will your partner be stepping up to take on other cards?",
      "resources": []
    },
    {
      "id": "new-job",
      "slug": "new-job",
      "sourceId": 58,
      "suit": "wild",
      "name": "New Job",
      "fullName": "New Job",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 960,
      "definition": "When you start a new job, you bring your A game daily, which may mean being the first one in, the last one to leave, working weekends, and doing whatever it takes to make an impression. Ask your partner to step up to the plate by taking some of your household and childcare cards while you concentrate on knocking it out of the park at work.",
      "conception": "The Wild suit includes life-changing scenarios that rock your world, and come with a mind-numbing amount of invisible work. When you’re dealt a Wild card (hopefully temporarily), you’re entitled to ask for additional help from your partner guilt-free. Your partner is encouraged to reach out to your village for even more support, but the Wild cardholder is not the one who handles this delegation. You and your partner are also encouraged to remove cards from your deck, temporarily, while dealing with a Wild card.",
      "planning": [],
      "execution": [],
      "msc": "Do you feel supported to take the lead on this wildcard? Will your partner be stepping up to take on other cards?",
      "resources": []
    },
    {
      "id": "serious-illness",
      "slug": "serious-illness",
      "sourceId": 55,
      "suit": "wild",
      "name": "Serious Illness",
      "fullName": "Serious Illness",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 970,
      "definition": "When a child falls ill, the implications can be life-changing. If you are managing someone else’s illness, it can require hours of research, doctors’ appointments, treatment plans, and medication monitoring. Thankfully, you can ask your partner to step in and support you. If, however, it’s you or your spouse who is ill, the healthier person may need to take on more cards in addition to holding this Wild card. Rather than allowing resentment or fear to build, ask for what you need and re-deal as circumstances change.",
      "conception": "The Wild suit includes life-changing scenarios that rock your world, and come with a mind-numbing amount of invisible work. When you’re dealt a Wild card (hopefully temporarily), you’re entitled to ask for additional help from your partner guilt-free. Your partner is encouraged to reach out to your village for even more support, but the Wild cardholder is not the one who handles this delegation. You and your partner are also encouraged to remove cards from your deck, temporarily, while dealing with a Wild card.",
      "planning": [],
      "execution": [],
      "msc": "Do you feel supported to take the lead on this wildcard? Will your partner be stepping up to take on other cards?",
      "resources": []
    },
    {
      "id": "welcoming-a-child-into-the-home",
      "slug": "welcoming-a-child-into-the-home",
      "sourceId": 59,
      "suit": "wild",
      "name": "Welcoming A Child Into The Home",
      "fullName": "Welcoming A Child Into The Home",
      "dailyGrind": false,
      "happinessTrio": false,
      "perPlayer": false,
      "playerSlot": null,
      "pairKey": null,
      "kids": false,
      "sortOrder": 980,
      "definition": "Never mind how often you’re puking and falling asleep on the couch by 6 p.m. Preparing for a baby increases your mental, physical, and emotional load exponentially. While you’re going to constant doctors’ appointments, registering for baby products that you never even knew existed (a Boppy pillow?) or that you would need (Nursing bras?), and listening to unwanted parenting advice from every other woman shopping in the baby basics aisle, ask your more hormonally balanced partner to take some additional cards. Ask him to hold on to them while you’re in labor because, um, you’re in labor. And while he’s at it, he may just as well hold on to them while you recover from giving birth.",
      "conception": "The Wild suit includes life-changing scenarios that rock your world, and come with a mind-numbing amount of invisible work. When you’re dealt a Wild card (hopefully temporarily), you’re entitled to ask for additional help from your partner guilt-free. Your partner is encouraged to reach out to your village for even more support, but the Wild cardholder is not the one who handles this delegation. You and your partner are also encouraged to remove cards from your deck, temporarily, while dealing with a Wild card.",
      "planning": [],
      "execution": [],
      "msc": "Do you feel supported to take the lead on this wildcard? Will your partner be stepping up to take on other cards?",
      "resources": [
        {
          "title": "Welcoming a Child Into the Home Guide",
          "url": "https://fairplay.myflodesk.com/welcomechild"
        }
      ]
    },
    {
      "id": "unicorn-space-player-1",
      "slug": "unicorn-space-player-1",
      "sourceId": 48,
      "suit": "unicorn",
      "name": "Unicorn Space",
      "fullName": "Unicorn Space (Player 1)",
      "dailyGrind": false,
      "happinessTrio": true,
      "perPlayer": true,
      "playerSlot": 1,
      "pairKey": "unicorn-space",
      "kids": false,
      "sortOrder": 990,
      "definition": "What makes you uniquely you and how do you share it with the world? Unicorn Space is about the passion and purpose that drive you to be the best version of yourself, and what’s on the line—your identity, fulfillment, and marriage—if you don’t nurture what makes you come alive. It may seem like a fairy tale to carve out time to get back to playing piano again, but it’s time to reclaim your gifts beyond your career and family without needing permission or feeling guilt.\n\nNote: An exercise class, a mani/pedi, hitting a sports bar with a buddy, or catching up on your social media feeds are not Unicorn Space. Your career may be if it’s a Category 5 storm of passion. Be realistic, but think big as you work to discover or reclaim your essence and talents. Both you and your partner must take this card!",
      "conception": "Unicorn Space is about the curiosity and purpose that drive you to be the best version of yourself.",
      "planning": [
        {
          "t": "li",
          "text": "Identify a curiosity – what would you like to create more time and mental and physical space for today?"
        },
        {
          "t": "li",
          "text": "Plan to share it with the world – when your Unicorn Space goes beyond yourself, it becomes so much bigger and that much more fulfilling."
        },
        {
          "t": "li",
          "text": "Set a goal – put yourself on a committed schedule that includes a specific timeline by which you will reveal it to others."
        },
        {
          "t": "li",
          "text": "Get your partner’s support and support them in return."
        },
        {
          "t": "li",
          "text": "Schedule a weekly time for your Unicorn Space and prioritize it!"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Reclaim your gifts beyond your family and career without needing permission."
        },
        {
          "t": "li",
          "text": "Don’t allow guilt, shame or “domestic encroachment” to cause you to miss your scheduled time."
        },
        {
          "t": "li",
          "text": "Share your Unicorn Space with the world!"
        }
      ],
      "msc": null,
      "resources": []
    },
    {
      "id": "unicorn-space-player-2",
      "slug": "unicorn-space-player-2",
      "sourceId": 49,
      "suit": "unicorn",
      "name": "Unicorn Space",
      "fullName": "Unicorn Space (Player 2)",
      "dailyGrind": false,
      "happinessTrio": true,
      "perPlayer": true,
      "playerSlot": 2,
      "pairKey": "unicorn-space",
      "kids": false,
      "sortOrder": 1000,
      "definition": "What makes you uniquely you, and how do you share it with the world? Unicorn Space is about the passion and purpose that drive you to be the best version of yourself, and what’s on the line—your identity, fulfillment, and marriage—if you don’t nurture what makes you come alive. It may seem like a fairy tale to carve out time to get back to playing piano again, but it’s time to reclaim your gifts beyond your career and family without needing permission or feeling guilt.\n\nNote: An exercise class, a mani/pedi, hitting a sports bar with a buddy, or catching up on your social media feeds are not Unicorn Space. Your career may be if it’s a Category 5 storm of passion. Be realistic, but think big as you work to discover or reclaim your essence and talents. Both you and your partner must take this card!",
      "conception": "Unicorn Space is about the curiosity and purpose that drive you to be the best version of yourself.",
      "planning": [
        {
          "t": "li",
          "text": "Identify a curiosity – what would you like to create more time and mental and physical space for today?"
        },
        {
          "t": "li",
          "text": "Plan to share it with the world – when your Unicorn Space goes beyond yourself, it becomes so much bigger and that much more fulfilling."
        },
        {
          "t": "li",
          "text": "Set a goal – put yourself on a committed schedule that includes a specific timeline by which you will reveal it to others."
        },
        {
          "t": "li",
          "text": "Get your partner’s support and support them in return."
        },
        {
          "t": "li",
          "text": "Schedule a weekly time for your Unicorn Space and prioritize it!"
        }
      ],
      "execution": [
        {
          "t": "li",
          "text": "Reclaim your gifts beyond your family and career without needing permission."
        },
        {
          "t": "li",
          "text": "Don’t allow guilt, shame or “domestic encroachment” to cause you to miss your scheduled time."
        },
        {
          "t": "li",
          "text": "Share your Unicorn Space with the world!"
        }
      ],
      "msc": null,
      "resources": []
    }
  ],
  "presets": [
    {
      "id": "no-kids",
      "label": "We don't have kids",
      "cardIds": [
        "childcare-helpers-kids",
        "meals-kids-school-lunch",
        "birthday-celebrations-other-kids",
        "extracurricular-kids-non-sports",
        "extracurricular-kids-sports",
        "packing-and-unpacking-kids-local",
        "school-breaks-kids-non-summer",
        "school-breaks-kids-summer",
        "school-forms-kids",
        "transportation-kids",
        "bathing-and-grooming-kids",
        "bedtime-routine-kids",
        "clothes-and-accessories-kids",
        "dental-kids",
        "diapering-and-potty-training-kids",
        "friendship-and-social-media-kids",
        "homework-projects-and-school-supplies-kids",
        "medical-and-healthy-living-kids",
        "school-service-kids",
        "school-transitions-kids",
        "special-needs-and-mental-health-kids",
        "teacher-communication-kids",
        "birthday-celebration-your-kids",
        "discipline-and-screen-time-kids",
        "fun-and-playing-kids",
        "gestures-of-love-kids",
        "hard-question-kids",
        "informal-education-kids",
        "magical-beings-kids",
        "middle-of-the-night-comfort-kids",
        "showing-up-and-participating-kids",
        "values-and-good-deeds-kids",
        "watching-kids"
      ]
    },
    {
      "id": "no-pets",
      "label": "We don't have pets",
      "cardIds": ["pets"]
    },
    {
      "id": "no-car",
      "label": "We don't have a car",
      "cardIds": ["auto"]
    },
    {
      "id": "no-yard",
      "label": "No yard or plants",
      "cardIds": ["lawn-and-plants"]
    }
  ]
}
